<template>
  <v-layout class="fullSize">
    <default-page
      v-if="error"
      :errorMessage="errorMessage"
      buttonText="Reload"
      @button-clicked="reloadPage"
    ></default-page>
    <div v-else style="width: 100%">
      <div v-if="isNotDesktop" class="navDraw-helper"></div>

      <v-flex class="fullSize">
        <loading-page
          v-if="
            loading || vuexIsLoading || loadingConfigurations || !settingsLoaded
          "
        ></loading-page>
        <!-- Show defaultpage if there are no instances running or if page is refreshing in order to show instances -->
        <div v-else-if="pageIsEmpty || pageWasEmpty">
          <default-page
            imageUrl="/img/dynamic-src-images/analytics.svg"
            :title="$options.name"
            text="It seems that you don't have any analytics instances running. Click Get Started below to add Applications"
            buttonText="Get Started"
            @button-clicked="
              $router.push({
                path: '/applications',
                query: {
                  add: true,
                },
              })
            "
          ></default-page>
        </div>

        <v-tabs
          v-else
          id="vTabsId"
          height="50"
          :background-color="$vuetify.theme.dark ? '#3d3d3d' : '#fff'"
          slot="extension"
          centered
          :value="tabs"
          hide-slider
          center-active
          show-arrows
          :slider-size="3"
        >
          <div
            v-if="
              $vuetify.breakpoint.xsOnly &&
              fetchAnalyticInstancesFiltered.length &&
              grids != null
            "
          >
            <v-menu
              v-model="currentTabItem.mobileModel"
              :disabled="
                (analyticInstances.length == 1 &&
                  !analyticInstances[0].mergedInstance) ||
                (analyticInstances.length == 3 &&
                  mergedInstances.length > 0 &&
                  !currentTabItem.mergedInstance)
              "
              offset-y
              :close-on-content-click="false"
              open-on-click
            >
              <template v-slot:activator="{ on }">
                <v-tab
                  v-on="on"
                  style="height: 50px"
                  class="vTabClassMobile char-lim-tabs"
                  active-class="selectedTab"
                >
                  <p v-if="currentTabItem.mergedInstance" class="my-auto">
                    {{ currentTabItem.name }} ({{
                      currentTabItem.subinstances.length
                    }})
                  </p>
                  <p v-else class="my-auto">{{ currentTabItem.name }}</p>
                </v-tab>
              </template>
              <v-card class="accent" width="100%">
                <v-row justify="center" class="mx-0">
                  <v-btn
                    v-if="
                      !currentTabItem.showMergeTabMobile &&
                      !currentTabItem.mergedInstance
                    "
                    @click="openMergePanel(currentTabItem.id)"
                    width="100%"
                    text
                    class="text-center mb-0"
                    style="font-size: 15px"
                    >Merge
                  </v-btn>
                  <div
                    v-else-if="
                      currentTabItem.mobileModel &&
                      currentTabItem.mergedInstance
                    "
                    style="width: 100%"
                  >
                    <v-row
                      v-for="item in getCurrentUpdatedItem.subinstances"
                      :key="item.id"
                      justify="space-between"
                      class="mx-0"
                      style="border-bottom: 1px solid rgb(255, 255, 255, 0.2)"
                    >
                      <p dense class="ml-4 my-1" style="font-size: 12px">
                        {{ item.name }}
                      </p>
                      <v-btn
                        @click="
                          updateMergedInstance(
                            MERGED_ACTIONS.REMOVE,
                            item.id,
                            currentTabItem.id
                          )
                        "
                        icon
                        x-small
                        class="mr-2 my-auto"
                      >
                        <v-icon small color="red">fas fa-times</v-icon>
                      </v-btn>
                    </v-row>

                    <v-btn
                      @click="toggleAddMoreInstancesTab(currentTabItem.id)"
                      :disabled="
                        !getCurrentUpdatedItem.availableInstances.length
                      "
                      small
                      text
                      :id="`addSubinstance${currentTabItem.id}`"
                      color="primary"
                      class="text-center mb-0"
                      style="width: 100%"
                    >
                      <v-icon x-small class="mr-1">fas fa-plus</v-icon>
                      Add More
                    </v-btn>

                    <v-menu
                      v-model="
                        mergeTabs[currentTabItem.id].addInstancesSelector
                      "
                      :activator="`#addSubinstance${currentTabItem.id}`"
                      offset-y
                      :close-on-click="true"
                    >
                      <v-list class="accent">
                        <v-list-item
                          v-for="item in currentTabItem.availableInstances"
                          :key="item.id"
                          @click="
                            updateMergedInstance(
                              MERGED_ACTIONS.ADD,
                              item.id,
                              currentTabItem.id,
                              item.name
                            )
                          "
                          style="min-height: 28px"
                        >
                          <p class="mb-0" style="font-size: 12px">
                            {{ item.name }}
                          </p>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <v-btn
                      @click="
                        destroyMergedInstance(
                          currentTabItem.id,
                          true,
                          false,
                          true
                        )
                      "
                      small
                      text
                      class="text-center mb-0 red--text"
                      style="width: 100%"
                      >destroy with ID{{ currentTabItem.id }}
                    </v-btn>

                    <p
                      v-if="currentTabItem.hideSeperated"
                      style="font-size: 12px"
                      class="badly-visible-text my-0 mx-1 text-center"
                    >
                      Subinstances are hidden
                    </p>
                  </div>
                </v-row>
                <div v-if="currentTabItem.showMergeTabMobile">
                  <p class="text-center my-2" style="font-size: 12px">
                    {{ currentTabItem.name }}
                  </p>
                  <v-row justify="center" class="mx-0">
                    <v-icon
                      x-small
                      style="
                        font-size: 8px;
                        transform: rotate(90deg);
                        height: 16px;
                      "
                      >icon-more-23x13
                    </v-icon>
                  </v-row>
                  <v-list
                    width="100%"
                    max-height="120px"
                    style="overflow-y: auto"
                  >
                    <v-list-item
                      v-for="mergable in mergeTargets"
                      :key="mergable.id"
                      @click="selectMergableInstance(mergable)"
                      class="px-1 clickable merge-select-item"
                      style="min-height: 32px; height: 32px"
                    >
                      <v-icon small color="primary">
                        {{
                          mergable.checked
                            ? "far fa-dot-circle"
                            : "radio_button_unchecked"
                        }}
                      </v-icon>
                      <p
                        class="primary--text mb-0 pl-2"
                        style="font-size: 14px"
                      >
                        {{ mergable.name }}
                      </p>
                    </v-list-item>
                  </v-list>

                  <v-tooltip content-class="tooltip-top-mg" bottom>
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-list-item
                          v-for="incomp in getInCompatibleInstances(
                            currentTabItem.id
                          )"
                          :key="incomp.id"
                          class="px-1 incomp-merge-select-item"
                          style="min-height: 32px; height: 32px"
                        >
                          <v-icon small color="grey">
                            {{
                              incomp.checked
                                ? "far fa-dot-circle"
                                : "radio_button_unchecked"
                            }}
                          </v-icon>
                          <p
                            class="grey--text mb-0 pl-2"
                            style="font-size: 14px"
                          >
                            {{ incomp.name }}
                          </p>
                        </v-list-item>
                      </div>
                    </template>
                    <span
                      >Can't merge to these instances due to<br />incompatibility
                      of summary table grouping</span
                    >
                  </v-tooltip>

                  <p
                    v-if="noInstancesSelected && mergePanelInitialInteraction"
                    class="red--text mt-1 ml-1 mb-0"
                    style="font-size: 12px; letter-spacing: 0.01em"
                  >
                    Select at least one instance
                  </p>

                  <v-tooltip right content-class="tooltip-top-mg">
                    <template v-slot:activator="{ on }">
                      <div :v-on="isNotDesktop ? 0 : on">
                        <v-checkbox
                          v-model="hideSeperatedInstances"
                          dense
                          x-small
                          hide-details
                          label="Hide subinstances"
                          class="extra-small-checkbox mt-0 pt-0"
                          on-icon="fas fa-check-square"
                          off-icon="far fa-check-square"
                        ></v-checkbox>
                      </div>
                    </template>
                    <span>Hide seperated instances</span>
                  </v-tooltip>

                  <v-checkbox
                    v-model="autoGenerateName"
                    dense
                    x-small
                    hide-details
                    label="Auto-generated name"
                    class="extra-small-checkbox mt-0 pt-0"
                    on-icon="fas fa-check-square"
                    off-icon="far fa-check-square"
                  ></v-checkbox>

                  <v-text-field
                    v-if="!autoGenerateName"
                    v-model="customMergeName"
                    label="Custom Name"
                    outlined
                    class="mini-text-field mt-1 ml-1"
                    dense
                    style="max-width: 150px; height: 30px"
                  ></v-text-field>

                  <v-row justify="center" class="mx-0">
                    <v-btn
                      @click="mergeInstances(currentTabItem)"
                      :disabled="noInstancesSelected"
                      text
                      small
                      class="text-center mt-1"
                      style="font-size: 16px; width: 100%"
                      >Ok
                    </v-btn>
                  </v-row>
                </div>
              </v-card>
            </v-menu>
          </div>

          <v-row v-else :key="vTabRenderKey" justify="center">
            <v-menu
              v-for="(instance, index) in analyticInstances"
              :key="instance.id"
              v-model="mergeTabs[instance.id].model"
              :disabled="disableTabsMenu(instance.id, instance.mergedInstance)"
              offset-y
              :close-on-content-click="false"
              :open-on-click="isNotDesktop"
              :open-on-hover="
                mergeTabs[instance.id].openOnHover && !isNotDesktop
              "
              content-class="m-t-n1"
            >
              <template v-slot:activator="{ on }">
                <v-tab
                  v-on="on"
                  @click="addItem(instance, index)"
                  transition="slide-x-transition"
                  class="vTabClass"
                  style="height: 50px"
                  active-class="selectedTab"
                >
                  <p v-if="instance.mergedInstance" class="my-auto">
                    {{ instance.name }} ({{ instance.subinstances.length }})
                  </p>
                  <p v-else class="my-auto">{{ instance.name }}</p>
                </v-tab>
              </template>
              <v-card class="accent" width="100%">
                <v-row justify="center" class="mx-0">
                  <v-btn
                    v-if="
                      !mergeTabs[instance.id].showMergeTab &&
                      !instance.mergedInstance
                    "
                    @click="openMergePanel(instance.id)"
                    width="100%"
                    text
                    class="text-center mb-0"
                    style="font-size: 15px"
                    >Merge
                  </v-btn>
                  <div
                    v-else-if="
                      mergeTabs[instance.id].model && instance.mergedInstance
                    "
                    style="width: 100%"
                  >
                    <v-row
                      v-for="item in instance.subinstances"
                      :key="item.id"
                      justify="space-between"
                      class="mx-0"
                      style="border-bottom: 1px solid rgb(255, 255, 255, 0.2)"
                    >
                      <p dense class="ml-4 my-1" style="font-size: 12px">
                        {{ item.name }}
                      </p>
                      <v-btn
                        @click="
                          updateMergedInstance(
                            MERGED_ACTIONS.REMOVE,
                            item.id,
                            instance.id
                          )
                        "
                        icon
                        x-small
                        class="mr-2 my-auto"
                      >
                        <v-icon small color="red">fas fa-times</v-icon>
                      </v-btn>
                    </v-row>
                    <v-row class="mx-0">
                      <v-btn
                        @click="toggleAddMoreInstancesTab(instance.id)"
                        :disabled="!instance.availableInstances.length"
                        small
                        text
                        :id="`addSubinstance${instance.id}`"
                        color="primary"
                        class="text-center mb-0"
                        style="width: 100%"
                      >
                        <v-icon x-small class="mr-1">fas fa-plus</v-icon>
                        Add More
                      </v-btn>
                      <v-menu
                        v-model="mergeTabs[instance.id].addInstancesSelector"
                        :activator="`#addSubinstance${instance.id}`"
                        offset-y
                      >
                        <v-list class="accent">
                          <v-list-item
                            v-for="item in instance.availableInstances"
                            :key="item.id"
                            @click="
                              updateMergedInstance(
                                MERGED_ACTIONS.ADD,
                                item.id,
                                instance.id,
                                item.name
                              )
                            "
                            style="min-height: 28px"
                          >
                            <p class="mb-0" style="font-size: 12px">
                              {{ item.name }}
                            </p>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <v-btn
                        @click="
                          destroyMergedInstance(instance.id, true, false, true)
                        "
                        small
                        text
                        class="text-center mb-0 red--text"
                        style="width: 100%"
                        >destroy
                      </v-btn>
                    </v-row>
                    <p
                      v-if="instance.hideSeperated"
                      style="font-size: 12px"
                      class="badly-visible-text my-0 mx-1 text-center"
                    >
                      Subinstances are hidden
                    </p>
                  </div>
                </v-row>
                <div v-if="mergeTabs[instance.id].showMergeTab">
                  <p class="text-center mt-2 mb-1" style="font-size: 12px">
                    {{ instance.name }}
                  </p>
                  <v-row justify="center" class="mx-0">
                    <v-icon
                      x-small
                      style="
                        font-size: 8px;
                        transform: rotate(90deg);
                        height: 16px;
                      "
                      class="mb-1"
                      >icon-more-23x13
                    </v-icon>
                  </v-row>

                  <v-row class="mx-0">
                    <v-list
                      width="100%"
                      max-height="120px"
                      style="overflow-y: auto"
                    >
                      <v-list-item
                        v-for="mergable in mergeTargets"
                        :key="mergable.id"
                        @click="selectMergableInstance(mergable)"
                        class="px-1 clickable merge-select-item"
                        style="min-height: 32px; height: 32px"
                      >
                        <v-icon small color="primary">
                          {{
                            mergable.checked
                              ? "far fa-dot-circle"
                              : "radio_button_unchecked"
                          }}
                        </v-icon>
                        <p
                          class="primary--text mb-0 pl-2"
                          style="font-size: 14px"
                        >
                          {{ mergable.name }}
                        </p>
                      </v-list-item>

                      <v-tooltip content-class="tooltip-top-mg" bottom>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-list-item
                              v-for="incomp in getInCompatibleInstances(
                                instance.id
                              )"
                              :key="incomp.id"
                              class="px-1 incomp-merge-select-item"
                              style="min-height: 32px; height: 32px"
                            >
                              <v-icon small color="grey">
                                {{
                                  incomp.checked
                                    ? "far fa-dot-circle"
                                    : "radio_button_unchecked"
                                }}
                              </v-icon>
                              <p
                                class="grey--text mb-0 pl-2"
                                style="font-size: 14px"
                              >
                                {{ incomp.name }}
                              </p>
                            </v-list-item>
                          </div>
                        </template>
                        <span
                          >Can't merge to these instances due to<br />incompatibility
                          of summary table grouping</span
                        >
                      </v-tooltip>
                    </v-list>
                  </v-row>
                  <p
                    v-if="noInstancesSelected && mergePanelInitialInteraction"
                    class="red--text mt-1 ml-1 mb-0"
                    style="font-size: 12px; letter-spacing: 0.01em"
                  >
                    Select at least one instance
                  </p>
                  <v-tooltip right content-class="tooltip-top-mg">
                    <template v-slot:activator="{ on }">
                      <div :v-on="isNotDesktop ? 0 : on">
                        <v-checkbox
                          v-model="hideSeperatedInstances"
                          dense
                          x-small
                          hide-details
                          label="Hide subinstances"
                          class="extra-small-checkbox mt-0 pt-0"
                          on-icon="fas fa-check-square"
                          off-icon="far fa-check-square"
                        ></v-checkbox>
                      </div>
                    </template>
                    <span>Hide seperated instances</span>
                  </v-tooltip>
                  <v-checkbox
                    v-model="autoGenerateName"
                    dense
                    x-small
                    hide-details
                    label="Auto-generated name"
                    class="extra-small-checkbox mt-0 pt-0"
                    on-icon="fas fa-check-square"
                    off-icon="far fa-check-square"
                  ></v-checkbox>
                  <v-text-field
                    v-if="!autoGenerateName"
                    v-model="customMergeName"
                    label="Custom Name"
                    outlined
                    class="mini-text-field mt-1 ml-1"
                    dense
                    style="max-width: 150px; height: 30px"
                  ></v-text-field>
                  <v-row justify="center" class="mx-0">
                    <v-btn
                      :disabled="noInstancesSelected"
                      @click="mergeInstances(instance)"
                      text
                      small
                      class="text-center mt-1"
                      style="font-size: 16px; width: 100%"
                      >Ok
                    </v-btn>
                  </v-row>
                </div>
              </v-card>
            </v-menu>
          </v-row>

          <v-tabs-items
            v-if="currentTabItem != null && currentTabItem.id != undefined"
            class="accent"
            v-model="currentTabItem.id"
            :style="`overflow: hidden auto;height: ${windowSizeY - 105}px;`"
          >
            <v-tab-item
              v-for="(instance, index) in analyticInstances"
              :key="instance.id"
              :value="instance.id"
              :disabled="true"
            >
              <div
                v-if="
                  isFrozenOrNotRunningMessage.message ||
                  (isFrozenOrNotRunningMessage.instances &&
                    isFrozenOrNotRunningMessage.instances.length)
                "
              >
                <p
                  v-if="isFrozenOrNotRunningMessage.message"
                  class="app-issue-info"
                >
                  <v-icon
                    style="font-size: 14px; margin-bottom: 4px"
                    color="red"
                    >fas fa-exclamation-triangle
                  </v-icon>
                  {{ isFrozenOrNotRunningMessage.message }}
                </p>
                <p
                  v-else-if="isFrozenOrNotRunningMessage.configsChanged"
                  class="app-issue-info"
                >
                  Configurations were changed, reloading this page..
                </p>
                <v-row v-else class="mx-1 app-issue-info simple-slow-opacityAN">
                  <p>
                    <v-icon
                      style="font-size: 14px; margin-bottom: 4px"
                      color="red"
                      >fas fa-exclamation-triangle
                    </v-icon>
                    Issues were found
                  </p>
                  <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        @click="() => {}"
                        v-on="on"
                        x-small
                        text
                        class="px-1 ml-1"
                      >
                        <p
                          class="red--text mb-0"
                          style="font-size: 12px; margin-top: 2px"
                        >
                          See more
                        </p>
                      </v-btn>
                    </template>
                    <v-card class="accent pa-1">
                      <tr
                        v-for="issue in isFrozenOrNotRunningMessage.instances"
                        :key="issue.id"
                        class="dataTableRow"
                        style="max-width: 300px; height: 28px"
                      >
                        <td>
                          <p class="my-1 mx-2" style="font-size: 12px">
                            {{ issue.name }}
                          </p>
                        </td>
                        <td>
                          <div
                            v-for="infoItem in issue.info"
                            :key="infoItem.text"
                            class="mx-2"
                          >
                            <v-icon
                              v-if="infoItem.type == INSTANCE_ISSUES.FROZEN"
                              x-small
                              color="primary"
                              style="margin-right: 2px"
                            >
                              fas fa-sync-alt
                            </v-icon>
                            <v-icon
                              v-else-if="
                                infoItem.type == INSTANCE_ISSUES.NOT_RUNNING
                              "
                              x-small
                              color="red"
                              style="font-size: 13px; margin-right: 2px"
                            >
                              far fa-play-circle
                            </v-icon>
                            <v-icon
                              v-else
                              x-small
                              color="red"
                              style="font-size: 13px; margin-right: 2px"
                            >
                              fas fa-wifi
                            </v-icon>
                            <p
                              class="my-1 ml-1"
                              style="font-size: 12px; display: inline"
                            >
                              {{ infoItem.text }}
                            </p>
                          </div>
                        </td>
                      </tr>
                    </v-card>
                  </v-menu>
                </v-row>
              </div>
              <grid-layout
                :class="$vuetify.theme.dark ? 'darkTheme' : 'lightTheme'"
                :layout="getLayout(instance.id)"
                :col-num="18"
                :row-num="2"
                :row-height="60"
                :min-h="6"
                :min-w="6"
                :is-draggable="isDraggableDesktop || isDraggable"
                :is-resizable="true"
                :is-mirrored="false"
                :use-css-transforms="true"
              >
                <div v-for="item in getLayout(instance.id)" :key="item.i">
                  <transition name="fade">
                    <grid-item
                      v-show="
                        !(item.tableName == 'exposure' && !showingExposureTable)
                      "
                      :dragAllowFrom="
                        $vuetify.breakpoint.smAndDown || isNotDesktop
                          ? '.dragFromHere'
                          : '.ag-body-viewport'
                      "
                      :x="item.x"
                      :y="item.y"
                      :w="item.w"
                      :h="item.h"
                      :i="item.i"
                      class="mt-3 draggable simple-slow-opacityAN"
                    >
                      <v-row v-show="isDraggable">
                        <v-col class="py-0" cols="3">
                          <v-avatar
                            size="41"
                            class="drag_thumb"
                            color="#1C6E59"
                          >
                            <v-icon color="white" class="dragFromHere"
                              >icon-4drag
                            </v-icon>
                          </v-avatar>
                        </v-col>
                      </v-row>
                      <ag-grid-vue
                        @dragStopped="
                          tableStateChange(
                            $event,
                            item.i,
                            'dragStopped',
                            item.tableName
                          )
                        "
                        @columnRowGroupChanged="
                          tableStateChange(
                            $event,
                            item.i,
                            'columnRowGroupChanged',
                            item.tableName
                          )
                        "
                        :id="
                          getTableDragVModel
                            ? 'dragable-grid'
                            : 'not-dragable-grid'
                        "
                        :class="
                          $vuetify.theme.dark
                            ? 'ag-theme-custom-balham-dark-vue'
                            : 'ag-theme-custom-balham-vue'
                        "
                        :pinnedBottomRowData="
                          item.i == '0' ? getPinnedBottomRowData : null
                        "
                        class="mt-1 queryBuilder--dark"
                        style="height: 100%; width: 100%"
                        @row-group-opened="rowExpanded"
                        @grid-ready="onGridReady(item.i)"
                        :gridOptions="getGridOptions(item.i, instance.id)"
                        :columnDefs="getColumnsDefs(item.i, instance)"
                        :immutableData="true"
                        :statusBar="statusBar"
                        :animateRows="true"
                        :enableRangeSelection="true"
                        :rowGroupPanelShow="rowGroupPanelShow"
                        :pivotPanelShow="pivotPanelShow"
                        :suppressAggFuncInHeader="true"
                        :getRowNodeId="(data) => getRowNodeId(data, instance)"
                        :defaultColDef="defaultColDef"
                        :autoGroupColumnDef="autoGroupColumnDef"
                        :getRowStyle="getRowStyle"
                        :groupRowAggNodes="getGroupRowAggNodes(item.i)"
                        :key="getKey(item.i, index)"
                      ></ag-grid-vue>
                    </grid-item>
                  </transition>
                </div>
              </grid-layout>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>

        <v-menu
          v-if="!loading && !pageIsEmpty && !pageWasEmpty"
          content-class="normal-menu w-220"
          transition="slide-y-transition"
          bottom
          style="right: 10px"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon class="white--text more-btn-analytics" v-on="on">
              <span
                style="
                  font-size: 28px;
                  margin-right: 2px;
                  letter-spacing: 0 !important;
                "
                class="icon-more-21x21"
              >
                <span class="path1 letterSpacing0"></span>
                <span class="path2 letterSpacing0"></span>
                <span class="path3 letterSpacing0"></span>
                <span class="path4 letterSpacing0"></span>
              </span>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              v-for="(item, i) in actionItems"
              :key="i"
              @click="item.action()"
            >
              <v-list-item-action class="mr-5">
                <v-icon
                  style="font-size: 20px"
                  :class="
                    item.clicked() ? 'primary--text' : 'supplementary-class'
                  "
                  >{{ item.icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  :class="
                    item.clicked() ? 'primary--text' : 'supplementary-class'
                  "
                  style="font-size: 15px"
                  >{{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-title
            v-if="$vuetify.breakpoint.xsOnly"
            style="
              border-radius: 4px 4px 0 0;
              font-size: 15px;
              letter-spacing: 0.04rem;
            "
            class="pl-4 mt-1 font-weight-bold list-title-background"
            >Instances
          </v-list-item-title>
          <v-list
            v-if="$vuetify.breakpoint.xsOnly"
            max-height="180"
            style="
              margin-top: 1px;
              overflow-y: auto;
              border-radius: 0 0 4px 4px;
            "
            dense
          >
            <v-list-item
              v-for="(item, index) in analyticInstances.filter(
                (el) => !el.mergedInstance
              )"
              :key="item.id"
              class="char-lim-more-menu"
              @click="addItem(item, index)"
            >
              <div
                :class="
                  currentTabItem.id == item.id
                    ? 'primary--text'
                    : 'supplementary-class'
                "
                style="font-size: 15px"
              >
                {{ item.name }}
              </div>
            </v-list-item>
          </v-list>
          <v-list-item-title
            v-if="$vuetify.breakpoint.xsOnly && mergedInstances.length"
            style="
              border-radius: 4px 4px 0 0;
              font-size: 15px;
              letter-spacing: 0.04rem;
            "
            class="pl-4 mt-1 font-weight-bold list-title-background"
            >Merged Instances
          </v-list-item-title>
          <v-list
            v-if="$vuetify.breakpoint.xsOnly && mergedInstances.length"
            max-height="180"
            style="margin-top: 1px; overflow-y: auto"
            dense
          >
            <v-list-item
              v-for="(item, index) in mergedInstances"
              :key="item.id"
              class="char-lim-more-menu"
              @click="addItem(item, index)"
            >
              <div
                justify="center"
                class="mx-1"
                :class="
                  currentTabItem.id == item.id
                    ? 'primary--text'
                    : 'supplementary-class'
                "
              >
                <p v-if="item.mergedInstance" class="my-auto">
                  {{ item.name }} ({{ item.subinstances.length }})
                </p>
                <p v-else class="my-auto">{{ item.name }}</p>
              </div>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-flex>
    </div>
  </v-layout>
</template>

<script>
import localForage from "localforage";

/** AG Grid Vue**/
import { AgGridVue } from "@ag-grid-community/vue";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { GridItem, GridLayout } from "vue-grid-layout";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { messageService } from "@/services/AnalyticsService";
import { ClipboardModule } from "@ag-grid-enterprise/clipboard";
import "ag-grid-enterprise";
import { pages_ENUMS, APP_STATE_SECTIONS } from "@/utilities/enums";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import { RangeSelectionModule } from "@ag-grid-enterprise/range-selection";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
/** **/

import {
  // source,
  // refreshCancelToken,
  SettingsService,
  ApplicationDefinitionService,
  ApplicationInstanceService,
} from "@/services/ApiService";
import {
  summaryColumnDefsFolded,
  summaryColumnDefsUnfolded,
  summaryColumnDefsFoldedNumeric,
  summaryColumnDefsUnfoldedNumeric,
  summaryColumnDefsFoldedMerged,
  summaryColumnDefsUnfoldedMerged,
  summaryColumnDefsFoldedNumericMerged,
  summaryColumnDefsUnfoldedNumericMerged,
  exposureColumnDefs,
  exposureColumnDefsNumeric,
  exposureColumnDefsMerged,
  exposureColumnDefsNumericMerged,
  defaultANStateInstance,
  ANPositionKeys,
} from "@/utilities/DefaultObjects";

import {
  LoadingPage,
  DefaultPage,
} from "../components/Default-Page-Components";

ModuleRegistry.registerModules([
  MenuModule,
  ClipboardModule,
  RowGroupingModule,
  ExcelExportModule,
  RangeSelectionModule,
  ClientSideRowModelModule,
  RowGroupingModule,
  RangeSelectionModule,
  MenuModule,
  ExcelExportModule,
  ClipboardModule,
]);

let HelperFunctions = {
  removeSubInstance: (settings, { mergedInstanceId, subInstanceId }) => {
    let mergedInstance = settings.mergedInstances.find(
      (el) => el.id == mergedInstanceId
    );
    mergedInstance.subinstances = mergedInstance.subinstances.filter(
      (el) => el.id != subInstanceId
    );
  },
  addSubInstance: (
    settings,
    { mergedInstanceId, subInstanceId, subInstanceName }
  ) => {
    let mergedInstance = settings.mergedInstances.find(
      (el) => el.id == mergedInstanceId
    );
    mergedInstance.subinstances.push({
      id: subInstanceId,
      name: subInstanceName,
    });
    // mergedInstance.subinstances = mergedInstance.subinstances.filter(
    //   (el) => el.id != ceId
    // );
  },
};

export default {
  name: "Analytics",
  data() {
    return {
      previousTablesSize: null,
      currentlyLoadingDataFor: null,
      INSTANCE_ISSUES: {
        NOT_RUNNING: 0,
        FROZEN: 1,
        DISCONNECTED: 2,
      },
      MERGED_ACTIONS: {
        REMOVE: 0,
        ADD: 1,
        DESTROY: 2,
      },
      subinstancesRemoved: [],
      customMergeName: null,
      autoGenerateName: true,
      mergePanelInitialInteraction: false, // Needed to keep error messages hidden when panel just opened
      noInstancesSelected: true,
      mergeTargets: [],
      resetErrorMessage: false,
      vTabRenderKey: 0,
      saveStateByApiAllowed: false,
      savedSelectedTabId: null,
      pageStateSaved: false,
      incompatibleInstances: [],
      mergeTabs: {}, // are used to track the state of v-menu component of each v-tab (merge panels)
      mergedInstances: [],
      hideSeperatedInstances: null,
      addingNewGrid: false,
      analyticInstancesInitialLoaded: false,
      analyticInstancesInitialLoadedValues: [],
      reloadingAN: false,
      error: false,
      errorMessage: null,
      loadingConfigurations: true,
      ANInstanceConfigs: [],
      vuexIsLoading: true,
      temporaryVar: 0,
      actionItems: [
        {
          type: "checkbox",
          icon: "icon-4drag",
          text: "Drag",
          action: () => {
            this.getTableDragVModel = !this.getTableDragVModel;
            if (this.getTableDragVModel) this.setDragTouchListeners();
          },
          clicked: () =>
            this.getTableDragVModel ? this.getTableDragVModel : false,
        },
        {
          type: "button",
          icon: "fas fa-redo-alt",
          text: "Reset Groups",
          action: this.resetColumnState,
          clicked: () => false,
        },
        {
          type: "checkbox",
          icon: "fas fa-list-ul",
          text: "Totals",
          action: this.showSummaryFooter,
          // action: () => {
          //   this.showingSummaryFooter = !this.showingSummaryFooter;
          // },
          clicked: () =>
            this.showingSummaryFooter ? this.showingSummaryFooter : false,
        },
        {
          type: "checkbox",
          icon: "fas fa-money-check-alt",
          text: "Exposure",
          action: this.showExposureTable,
          clicked: () =>
            this.showingExposureTable ? this.showingExposureTable : false,
        },
      ],
      showingExposureTable: true,
      showingSummaryFooter: false,
      getRowStyle: null,
      pinnedBottomRowData: [],
      currentTabItem: { id: -1 },
      isDraggable: false,
      isDraggableDesktop: false,
      resizingATableRightNow: false,
      exposureTableId: "1",
      summaryTableId: "0",
      theme: "darkTheme",
      currentLayout: [],
      tabs: null,
      grids: null,
      statusBar: null,
      rowGroupPanelShow: null,
      pivotPanelShow: null,
      getRowNodeId: null,
      defaultColDef: null,
      autoGroupColumnDef: null,
      loading: true,
      instances: null,
    };
  },
  props: {
    pageReloaded: {
      type: Boolean,
      default: true,
    },
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    windowSizeY: {
      type: Number,
      default: 0,
    },
    settingsLoaded: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AgGridVue,
    GridLayout,
    GridItem,
    LoadingPage,
    DefaultPage,
  },
  computed: {
    getEnabledApplicationInstances() {
      return this.getApplicationInstances.filter((el) => {
        return this.ANInstanceConfigs.some(
          (config) => config.id == el.id && config.Enabled
        );
      });
    },
    getCurrentUpdatedItem: {
      get() {
        return this.analyticInstances.find(
          (el) => el.id == this.currentTabItem.id
        );
      },
      set() {},
    },
    pageWasEmpty() {
      // is used to keep the empty page state true while reloading the page because new instances were created
      return (
        !this.pageIsEmpty &&
        (this.grids == null ||
          (typeof this.grids == "object" && !Object.keys(this.grids).length)) &&
        this.reloadingAN
      );
    },
    isFrozenOrNotRunningMessage() {
      if (this.resetErrorMessage) return {};
      let instance = this.analyticInstances.find(
        (el) => el.id == this.currentTabItem.id
      );
      if (this.loading || this.pageIsEmpty) return { message: "Loading.." };

      let problemIndicator = { instances: [], configsChanged: false };

      if (instance.mergedInstance) {
        // Return an object with a message && an optional array of problems which will be used for a v-menu witha list of problems

        instance.subinstances.forEach((el) => {
          let instanceConfig = this.ANInstanceConfigs.find(
            (inst) => inst.id == el.id
          );
          if (instanceConfig) {
            if (
              instanceConfig.hasOwnProperty("freezeAnalytics") &&
              instanceConfig.freezeAnalytics
            ) {
              if (this.reloadingAN && !problemIndicator.configsChanged)
                problemIndicator.configsChanged = true;
              problemIndicator.instances.push({
                name: el.name,
                id: el.id,
                info: [
                  { text: "Reload Needed", type: this.INSTANCE_ISSUES.FROZEN },
                ],
              });
            }
          }
        });

        instance.subinstances.forEach((sub, i) => {
          let filteredInstance = this.fetchAnalyticInstancesFiltered.find(
            (inst) => inst.id == sub.id
          );

          let id = filteredInstance != undefined ? filteredInstance.id : sub.id;
          let name =
            filteredInstance != undefined ? filteredInstance.name : sub.name;

          let problematicInstance = problemIndicator.instances.find(
            (el) => el.id == id
          );

          if (filteredInstance != undefined) {
            if (filteredInstance.appStatus != "RUN") {
              if (problematicInstance != undefined) {
                problematicInstance.info.push({
                  text: "Not running",
                  type: this.INSTANCE_ISSUES.NOT_RUNNING,
                });
              } else
                problemIndicator.instances.push({
                  name: name,
                  id: id,
                  info: [
                    {
                      text: "Not running",
                      type: this.INSTANCE_ISSUES.NOT_RUNNING,
                    },
                  ],
                });
            } else if (filteredInstance.serverStatus == "DISCONNECTED") {
              // If application is running check that server is connected
              let info = {
                text: "Disconnected",
                type: this.INSTANCE_ISSUES.DISCONNECTED,
              };
              if (problematicInstance != undefined) {
                problematicInstance.info.push(info);
              } else
                problemIndicator.instances.push({
                  name: name,
                  id: id,
                  info: [info],
                });
            }
          } else {
            if (problematicInstance != undefined)
              problematicInstance.info.push({
                text: "Not running",
                type: this.INSTANCE_ISSUES.NOT_RUNNING,
              });
            else
              problemIndicator.instances.push({
                name: name,
                id: id,
                info: [
                  {
                    text: "Not running",
                    type: this.INSTANCE_ISSUES.NOT_RUNNING,
                  },
                ],
              });
          }
        });
      } else {
        problemIndicator.message = this.getInstanceSetting(instance)
          .freezeAnalytics
          ? this.reloadingAN
            ? "Configurations were changed, reloading this page.."
            : "Configurations were changed, reload this instance."
          : instance.appStatus != "RUN"
          ? "This Application is not running."
          : instance.serverStatus == "DISCONNECTED"
          ? "Server is disconnected"
          : "";
      }
      return problemIndicator;
    },
    analyticInstances() {
      let fetchedInstances = this.addingNewGrid
        ? "analyticInstancesInitialLoadedValues"
        : "fetchAnalyticInstancesFiltered"; // addingNewGrid indicates that a new instance was created but is not yet visible for the user
      let instances = this[fetchedInstances].filter((appInstance) => {
        // removing(hiding) instances that are children of mergedInstsWithHiddenChildren
        let mergedInstsWithHiddenChildren = this.mergedInstances.filter(
          (el) => el.hasOwnProperty("hideSeperated") && el.hideSeperated
        );
        let remove = mergedInstsWithHiddenChildren.some((el) =>
          el.subinstances.some((subInst) => subInst.id == appInstance.id)
        );
        if (remove) return false;
        else return true;
      });
      return instances.concat(this.mergedInstances); // analyticInstancesInitialLoadedValues are the instances before the new instance was added
    },
    getPinnedBottomRowData(tableId) {
      if (this.showingSummaryFooter) {
        let data;
        if (this.temporaryVar) {
          // the temporaryVar is used for reactivity
          data = this.pinnedBottomRowData.find((el) => {
            return el.serverId == this.currentTabItem.id;
          });
        }
        return data == undefined ? [] : data.totals;
      } else {
        return null;
      }
    },
    pageIsEmpty() {
      let pageEmpty =
        this.fetchAnalyticInstancesFiltered.length == 0 || this.grids == null;
      return pageEmpty;
    },
    getTableDragVModel: {
      get() {
        return this.isNotDesktop ? this.isDraggable : this.isDraggableDesktop;
      },
      set(newVal) {
        this.isNotDesktop
          ? (this.isDraggable = newVal)
          : (this.isDraggableDesktop = newVal);
      },
    },
    getCurrentLayout() {
      let x = this.instances.find((el) => {
        return el.id == this.currentTabItem.id;
      });
      return x.layout;
    },
    fetchAnalyticInstancesFiltered: function () {
      return this.getEnabledApplicationInstances;
    },
    ...mapGetters("instances", ["getApplicationInstances", "instancesLoaded"]),
    ...mapGetters(["getMiniDrawer"]),
    ...mapGetters(["isAdmin"]),
    ...mapGetters(["getSpecificSetting", "getSettings"]),
  },
  methods: {
    emitSettingsUpdateToApp(options) {
      let updateOptions = {
        section: APP_STATE_SECTIONS.ANALYTICS,
        mutation: options.mutation,
      };

      if (options.hasOwnProperty("innerSection"))
        updateOptions.innerSection = options.innerSection;

      this.$emit("update-app-state", updateOptions);
    },
    removeMergedInstance(settings, instanceToRemove) {
      settings.mergedInstances = settings.mergedInstances.filter(
        (el) => el.id != instanceToRemove
      );
      settings.instances = settings.instances.filter(
        (el) => el.id != instanceToRemove
      );
      settings.selectedInstance = this.currentTabItem.id;
    },
    updateAppStateRemotelyAndLocally(options = null) {
      let settings = this.getCurrentPageState({
        tabId: this.currentTabItem.id,
        ...options,
      });

      this.emitSettingsUpdateToApp({
        section: APP_STATE_SECTIONS.ANALYTICS,
        mutation: settings,
      });
    },
    // DESCRIPTION:
    // Create an object containing the latest state of the current tab.
    // The object contains the instances[] and mergedInstances[]
    // each object in instances[] contains layout, exposure, summary & ID properties
    getCurrentPageState(options) {
      let { tabId, setDefaultTabState, tableType, action, actionOptions } =
        options;

      let isAMergedInstance = this.currentTabItem.mergedInstance;

      let settings = JSON.parse(
        JSON.stringify(
          this.getSpecificSetting({
            section: "applicationState",
            innerSection: "analytics",
          })
        )
      );

      switch (action) {
        // DESCRIPTION:
        // Remove a merged instance from settings
        // CASE: In case the getCurrentPageState() was called because a merged instance was destroyed
        case this.MERGED_ACTIONS.DESTROY:
          this.removeMergedInstance(settings, actionOptions.instanceId);
          return settings;
        case this.MERGED_ACTIONS.REMOVE:
          HelperFunctions.removeSubInstance(settings, actionOptions);
          break;
        case this.MERGED_ACTIONS.ADD:
          HelperFunctions.addSubInstance(settings, actionOptions);
          break;
      }

      let instance = this.instances.find((el) => el.id == tabId);

      // If instance is undefined then something definitely went wrong
      if (!instance) {
        return;
      }

      let itemIndex = settings.instances.findIndex((el) => el.id == tabId);

      let updatedSetting;

      // DESCRIPTION:
      // If flag setDefaultTabState is true then set the default tab settings
      // CASE: When a new merged-instance is created, it gets the default tab state (e.g default layout, default columns & grouping etc.)
      if (setDefaultTabState) {
        updatedSetting = defaultANStateInstance.setInstance(tabId);
        // // remove unnecesary id field
        // delete updatedSetting.id;
      } else {
        // DESCRIPTION:
        // The itemIndex != -1 means that an isntance with this tabs' ID exists in settings.instances
        // which means that you can use it to create the "updatedSetting" object
        // otherwise create a new "updatedSetting" object from scratch
        if (itemIndex != -1) {
          let outDatedState = null;
          outDatedState = settings.instances[itemIndex];
          updatedSetting = JSON.parse(
            JSON.stringify(
              Object.assign(outDatedState, {
                layout: instance.layout,
                // There is no point setting the ID since that instance already has an id and it itemIndex was found using that id
                // id: tabId,
              })
            )
          );
        } else {
          updatedSetting = {
            summary: [],
            exposure: [],
            layout: instance.layout,
            id: tabId,
          };
        }

        // DESCRIPTION:
        // In case the reason the getCurrentPageState was called is for a change on the table
        // Then updatedSetting should have the new state of that table
        // Save columns state
        if (tableType == "summary")
          updatedSetting.summary =
            this.grids[tabId].summary.gridOptions.columnApi.getColumnState();
        else if (tableType == "exposure" && this.showingExposureTable) {
          updatedSetting.exposure =
            this.grids[tabId].exposure.gridOptions.columnApi.getColumnState();
        }
      }
      if (isAMergedInstance) {
        var updatedSettingOfMergedInstance = JSON.parse(
          JSON.stringify(this.mergedInstances.find((el) => el.id == tabId))
        );
      }

      // DESCRIPTION:
      // If the instance/tab already exists in saved settings then just update it
      // Otherwise add it
      if (itemIndex != -1) {
        settings.instances[itemIndex] = updatedSetting;
        if (isAMergedInstance) {
          var mergedItemIndex = settings.mergedInstances.findIndex(
            (el) => el.id == updatedSettingOfMergedInstance.id
          );
          settings.mergedInstances[mergedItemIndex] =
            updatedSettingOfMergedInstance;
        }
      } else {
        settings.instances.push(updatedSetting);
        if (isAMergedInstance) {
          settings.mergedInstances.push(updatedSettingOfMergedInstance);
        }
      }

      // Save the currently selected tab
      settings.selectedInstance = this.currentTabItem.id;

      return settings;
    },
    gridResized(ev, tableId) {
      let eventIsAnObject = typeof ev == "object";
      let columnWidthResized =
        eventIsAnObject &&
        ev.hasOwnProperty("target") &&
        ev.target.className.includes("ag-header-cell-resize");
      // If the table event was triggered by a resize of a column, return since calling fitColumns() doesn't make sense
      if (columnWidthResized) return;

      let tableResizedManually = ev == "onmouseup";
      let columnResizedFromUI = false,
        sizedColumnsToFit = false,
        columnRowGroupChangedByApi = false,
        columnsResizedByApi = false,
        columnMoved = false,
        columnVisiblityChangedByApi = false;
      if (eventIsAnObject) {
        columnMoved = ev.type == "columnMoved";
        columnRowGroupChangedByApi =
          ev.type == "columnRowGroupChanged" && ev.source == "api";
        columnResizedFromUI =
          ev.type == "columnResized" && ev.source == "uiColumnDragged";
        sizedColumnsToFit =
          ev.source == "sizeColumnsToFit" && ev.type == "columnResized";
        columnsResizedByApi = ev.type == "columnResized" && ev.source == "api";
        columnVisiblityChangedByApi =
          ev.type == "columnVisible" && ev.source == "api";
      }

      if (
        !sizedColumnsToFit &&
        !columnsResizedByApi &&
        !columnResizedFromUI &&
        !columnMoved &&
        !columnRowGroupChangedByApi &&
        !columnVisiblityChangedByApi
      ) {
        if (tableResizedManually) {
          let tablesToResize = {
            summary: tableId == 0,
            exposure: tableId == 1,
          };
          this.fitColumns(ev, tablesToResize);
        } else {
          this.fitColumns(ev);
        }
      }
    },
    getIdOfModifiedTable() {
      if (!this.previousTablesSize) {
        return null;
      }
      let previousSummary = this.previousTablesSize[0];
      let previousExposure = this.previousTablesSize[1];
      let currentSummary = this.getCurrentLayout[0];
      let currentExposure = this.getCurrentLayout[1];
      let changedTableId = null;
      if (
        previousSummary.w != currentSummary.w ||
        previousSummary.h != currentSummary.h
      ) {
        changedTableId = "0";
      } else if (
        previousExposure.w != currentExposure.w ||
        previousExposure.h != currentExposure.h
      ) {
        changedTableId = "1";
      }
      return changedTableId;
    },
    getPositionsFetchParams(exposureOnly = false) {
      // let folded = this.isGoupedBySymbol(subinstance);
      let params = { command: "CMD_CSM_11" };
      // When exposure is hidden fetch only Positions
      if (this.showingExposureTable) {
        params.payload = JSON.stringify({
          data_type: exposureOnly ? 1 : 2,
          exec_type: 1,
        });
      } else {
        params.payload = JSON.stringify({ data_type: 0, exec_type: 1 });
      }
      return { params };
    },
    // DESCRIPTION: Update grid data (summary or exposure depending on tableType)
    // WORKFLOW: If current inst. is a merged inst. then call mergeDataAndUpdateGrid otherwise call updateGridData
    handleNewData(serverId, data, tableType) {
      let merged = this.currentTabItem.mergedInstance;
      if (merged)
        this.mergeDataAndUpdateGrid(
          serverId,
          tableType,
          JSON.parse(JSON.stringify(data))
        );
      else this.updateGridData(data, serverId, tableType); // Update the original grid set
    },
    // DESCRIPTION: For each subinstance - fetch data, process it, merge with previous and update the table
    // WORKFLOW: the reason for updating the table on each loop cycle is for a smoother UX
    async fetchAndSetMergedTableData(exposureOnly = false) {
      let loadingDataFor = this.currentTabItem.id;
      let subinstances = this.currentTabItem.subinstances.map((el) => {
        return { name: el.name, id: el.id };
      });
      const { params } = this.getPositionsFetchParams(exposureOnly);
      for (const subinstance of subinstances) {
        // In case user switched to another tab before the data for current tab was loaded.. stop the loop
        if (this.currentlyLoadingDataFor != loadingDataFor) {
          continue;
        }

        let instanceIsRunning = this.fetchAnalyticInstancesFiltered.some(
          (el) =>
            el.id == subinstance.id &&
            el.appStatus == "RUN" &&
            el.serverStatus == "CONNECTED"
        );
        if (!instanceIsRunning) {
          continue;
        }
        await ApplicationInstanceService.put(subinstance.id, params).catch(
          (error) => {
            console.error(error);
            if (
              this.isAdmin &&
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              this.$notifier.error(error.response.data.message);
            }
          }
        );
      }
      // Data loading is done, clear the currentlyLoadingDataFor var
      this.currentlyLoadingDataFor = null;
    },
    async fetchAndSetSubinstance(subInstanceId) {
      const { params } = this.getPositionsFetchParams();
      // Fecth subinstance's data
      await ApplicationInstanceService.put(subInstanceId, params)
        .catch((error) => {
          if (
            this.isAdmin &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.$notifier.error(error.response.data.message);
          }
        })
        .finally(() => {
          // Data loading is done so clear the currentlyLoadingDataFor var
          this.currentlyLoadingDataFor = null;
        });
    },
    // DESCRIPTION: Fetch & Set the table data using CMD_CSM_11 a.k.a CMD_AN_GET_POSITIONS
    fetchAndSetTableData(exposureOnly = false) {
      const { params } = this.getPositionsFetchParams(exposureOnly);

      ApplicationInstanceService.put(this.currentTabItem.id, params)
        .catch((error) => {
          if (
            this.isAdmin &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.$notifier.error(error.response.data.message);
          }
        })
        .finally(() => {
          // Data loading is done so clear the currentlyLoadingDataFor var
          this.currentlyLoadingDataFor = null;
        });
    },
    clearUnfocusedTable(previousTabId) {
      if (!this.grids || !this.grids.hasOwnProperty(previousTabId)) return;
      if (
        !this.grids[previousTabId] ||
        !this.grids[previousTabId].summary.gridOptions.hasOwnProperty("api") ||
        this.grids[previousTabId].summary.gridOptions.api == null
      ) {
        return;
      }

      this.updateGridData([], previousTabId, "PositionsSummary");
      if (this.showingExposureTable)
        this.updateGridData([], previousTabId, "PositionsExposure");
    },
    disableTabsMenu(instanceId, isMergedInstance) {
      // Is there a merged instance which has all of current instances as its' subinstances
      let allInstancesAreMerged = true;
      allInstancesAreMerged = this.mergedInstances.some((merged) => {
        return this.fetchAnalyticInstancesFiltered.every((sub) =>
          merged.subinstances.some((inst) => inst.id == sub.id)
        );
      });

      return (
        !isMergedInstance && // Disabled can only be a single instance
        (this.analyticInstances.length == 1 || // Its the only instance available
          allInstancesAreMerged ||
          (this.isNotDesktop && instanceId != this.currentTabItem.id)) // (Only on tablets) Disable if this instance is not the currently selected one
      );
    },
    removeOldDB() {
      localForage.keys((value, keys) => {
        let itemsToRemove = keys.filter((el) => el.startsWith("AN-data-"));
        itemsToRemove.forEach((item) => {
          localForage.removeItem(item, (err) => {
            if (err != null)
              console.error(`Couldn't remove item ${item} from IndexedDB`);
          });
        });
      });
    },
    isEmptyMessage(message, numericData) {
      return !(numericData ? message[2].length : message.data.length);
    },
    getNumericDataTotals(messageData, groupedBySymbol = null) {
      // to getNumericDataTotals vasta reference so you need to JSONpasre/stringify it
      if (!messageData.length) return [];

      let keys = ANPositionKeys.numeric;

      let initialArray = JSON.parse(JSON.stringify(messageData[0]));

      let sumCount = true;
      if (groupedBySymbol != null) {
        if (groupedBySymbol) initialArray[15] = " ";
        else {
          sumCount = false;
          initialArray[13] = " ";
          initialArray[14] = " ";
          initialArray[15] = " ";
          initialArray[16] = " ";
        }
      }

      let totalsArray = messageData.reduce((sum, curr, index) => {
        if (index == 0) return sum;
        if (sumCount) sum[keys.Count] += curr[keys.Count];
        sum[keys.BuyVolume] += curr[keys.BuyVolume];
        sum[keys.SellVolume] += curr[keys.SellVolume];
        sum[keys.NetVolume] += curr[keys.NetVolume];
        sum[keys.Profit] += curr[keys.Profit];
        sum[keys.Swap] += curr[keys.Swap];
        sum[keys.Commision] += curr[keys.Commision];
        sum[keys.NotionalValue] += curr[keys.NotionalValue];

        return sum;
      }, initialArray);
      return totalsArray;
    },
    getJSONDataTotals(messageData) {
      let totalsArray = messageData.reduce((sum, curr, index) => {
        if (index == 0) return sum;
        return {
          Count: sum["Count"] + curr["Count"],
          BuyVolume: sum["BuyVolume"] + curr["BuyVolume"],
          SellVolume: sum["SellVolume"] + curr["SellVolume"],
          NetVolume: sum["NetVolume"] + curr["NetVolume"],
          Profit: sum["Profit"] + curr["Profit"],
          Swap: sum["Swap"] + curr["Swap"],
          Commision: sum["Commision"] + curr["Commision"],
          NotionalValue: sum["NotionalValue"] + curr["NotionalValue"],
        };
      }, JSON.parse(JSON.stringify(messageData[0])));
      return totalsArray;
    },
    // Handle ag-grid bug of placing the grouping column at the end of the table
    // Ag-grid issue: https://github.com/ag-grid/ag-grid/issues/4405
    fixWrongGroupingColumnPlacement(table) {
      const columnGroupIndex = table.gridOptions.columnApi
        .getColumnState()
        .findIndex((column) => column.colId === "ag-Grid-AutoColumn");

      if (columnGroupIndex > -1) {
        table.gridOptions.columnApi.moveColumnByIndex(columnGroupIndex, 0);
      }
    },
    isNumeric(data) {
      return Array.isArray(data);
    },
    outdatedVersionData(name) {
      // For backward compatibility purposes check if data saved in vuex is of an outdated structure
      return typeof name == "object";
    },
    closeAllMenus() {
      let mergeTabs = JSON.parse(JSON.stringify(this.mergeTabs));

      Object.keys(mergeTabs).forEach((el) => {
        let tab = mergeTabs[el];
        if (tab.model) tab.model = false;
        if (tab.showMergeTab) tab.model = false;
        if (!tab.openOnHover) tab.model = true;
        if (tab.addInstancesSelector) tab.model = false;
      });

      this.mergeTabs = mergeTabs;
    },
    removeIncompatiblesData() {
      // Deleting all removed Subinstances for IndexedDB

      this.incompatibleInstances.forEach((mergedInstSubs) => {
        mergedInstSubs.forEach((sub) => {
          if (this.subinstancesRemoved.every((el) => el != sub.id)) {
            this.subinstancesRemoved.push(sub.id);
          }
        });
      });

      this.subinstancesRemoved.forEach((el) => {
        this.removeInstanceDataFromDB(el);
      });
    },
    focusOnTheRightTab() {
      if (this.tabs == null) return;
      if (
        this.tabs >= this.analyticInstances.length ||
        this.analyticInstances[this.tabs].id != this.currentTabItem.id
      ) {
        let index = this.analyticInstances.findIndex(
          (el) => el.id == this.currentTabItem.id
        );
        this.addItem(this.currentTabItem, index, false, false, false);
      }
    },
    calculateMergedInstancesInfo() {
      this.mergedInstances = this.mergedInstances.map((merged) => {
        merged.availableInstances = this.getAvailableInstances(
          merged.subinstances,
          merged.groupBySymbol
        );
        return merged;
      });
    },
    getAvailableInstances(subinstances, mergedInstgroupBySymbol) {
      return this.fetchAnalyticInstancesFiltered.filter(
        (
          el // Filter compatible and instances that aren't yet a subinstance
        ) => {
          return (
            subinstances.every((sub) => sub.id != el.id) &&
            this.isGoupedBySymbol(el) == mergedInstgroupBySymbol
          );
        }
      );
    },
    getUniqueMergedId(selectedMergeTargets, source) {
      let mergedId =
        source.id +
        selectedMergeTargets.reduce((final, next) => {
          final += "-";
          final += next.id;
          return final;
        }, "");

      let uniqueIdFound = false;
      let i = 0;

      while (!uniqueIdFound) {
        if (!i && this.mergedInstances.some((el) => el.id == mergedId)) {
          mergedId += "-2";
        } else if (this.mergedInstances.some((el) => el.id == mergedId)) {
          mergedId = mergedId.slice(0, -1) + `${i + 1}`;
        } else uniqueIdFound = true;
        i++;
      }

      return mergedId;
    },
    // DESCRIPTION:
    // Removes subinstance from IndexedDB (removes data) and from vuex's pageState
    // also removes it from memory ("memory" as in from variable binded to rendered page components)
    // Also adds/creates a tab if the instance was hidden
    removeSubinstanceLocally(subInstanceId, mergedInstance) {
      this.removeInstanceDataFromDB(subInstanceId);

      if (mergedInstance.hideSeperated) {
        this.addNewInstance(subInstanceId);
        let mergeTabs = JSON.parse(JSON.stringify(this.mergeTabs));
        mergeTabs[subInstanceId] = {
          model: false,
          showMergeTab: false,
          openOnHover: true,
        };
        this.mergeTabs = Object.assign({}, mergeTabs);
      }

      if (mergedInstance.hideSeperated) {
        // if children are hidden then close all menus & panels because v-tab(s) will be rerendered and will be different
        this.closeAllMenus();
      }

      mergedInstance.subinstances = mergedInstance.subinstances.filter(
        (el) => el.id != subInstanceId
      );

      // this.updateMergedInstancesState();
    },
    // updateMergedInstancesState() {
    //   // remove from vuex instances the mergedInstances that do now exist in vuex mergedInstances
    // },
    updateMergedInstance(
      action,
      subInstanceId,
      mergedInstanceId,
      subInstanceName = null
    ) {
      let mergedInstance = this.mergedInstances.find(
        (el) => el.id == mergedInstanceId
      );
      var subInstanceName;
      let subInstance = mergedInstance.subinstances.find(
        (el) => el.id == subInstanceId
      );
      if (subInstance) subInstanceName = subInstance.name;
      else
        subInstanceName = this.fetchAnalyticInstancesFiltered.find(
          (el) => el.id == subInstanceId
        ).name;

      switch (action) {
        case this.MERGED_ACTIONS.REMOVE:
          if (mergedInstance.subinstances.length < 2)
            this.destroyMergedInstance(mergedInstanceId, true);
          else this.removeSubinstanceLocally(subInstanceId, mergedInstance);

          mergedInstance.availableInstances.push({
            name: subInstanceName,
            id: subInstanceId,
          });

          if (mergedInstance.subinstances.length)
            this.$notifier.info(
              "Instance removed. Table data will be removed on the next execution",
              {
                link: "http://dealio.ai/docs/en/ui/analytics#adding--removing-sub-instances-from-a-merged-instance",
              }
            );

          if (mergedInstance.hideSeperated) this.reRenderTabsBar();

          this.updateAppStateRemotelyAndLocally({
            action: this.MERGED_ACTIONS.REMOVE,
            actionOptions: {
              mergedInstanceId: mergedInstanceId,
              subInstanceId: subInstanceId,
            },
          });

          break;

        case this.MERGED_ACTIONS.ADD:
          if (mergedInstance.hideSeperated)
            // if children are hidden then close all menus & panels because v-tab(s) will be rerendered and will be different
            this.closeAllMenus();

          mergedInstance.subinstances.push({
            name: subInstanceName,
            id: subInstanceId,
          });

          // Used to ignore the unwanted sse data
          let currentTableAgentIds = this.currentTabItem.mergedInstance
            ? this.currentTabItem.subinstances.map((el) => el.id)
            : [this.currentTabItem.id];
          this.$emit(
            "analytics-tab-change",
            JSON.parse(JSON.stringify(currentTableAgentIds))
          );

          mergedInstance.availableInstances =
            mergedInstance.availableInstances.filter(
              (el) => el.id != subInstanceId
            );
          // this.updateMergedInstancesState();
          this.updateAppStateRemotelyAndLocally({
            action: this.MERGED_ACTIONS.ADD,
            actionOptions: {
              mergedInstanceId: mergedInstanceId,
              subInstanceId: subInstanceId,
              subInstanceName: subInstanceName,
            },
          });
          this.$notifier.info(
            "Instance added. Table data will be updated shortly",
            {
              link: "http://dealio.ai/docs/en/ui/analytics#adding--removing-sub-instances-from-a-merged-instance",
            }
          );
          this.fetchAndSetSubinstance(
            subInstanceId,
            mergedInstanceId,
            subInstanceName
          );
          break;
      }

      if (this.$vuetify.breakpoint.xsOnly) {
        // update subinstances on mobile view
        this.currentTabItem.subinstances = JSON.parse(
          JSON.stringify(mergedInstance.subinstances)
        );
      }
    },
    getMergedInstancesToUpdate(serverId) {
      let mergedInstancesToUpdate = this.mergedInstances.reduce(
        (final, next) => {
          if (next.subinstances.some((sub) => sub.id == serverId)) {
            final.push({ mergedId: next.id, subinstances: next.subinstances });
          }
          return final;
        },
        []
      );

      return JSON.parse(JSON.stringify(mergedInstancesToUpdate));
    },
    getCommonSubinstances(mergedInstances) {
      let commonSubs = []; // Common children instances of mergedInstancesToUpdate
      let allSubInstancesArrays = mergedInstances.map((el) => el.subinstances);

      allSubInstancesArrays.forEach((subArray, index) => {
        let filtered = subArray.filter((sub) => {
          let isCommonSub = false;
          for (let i = index + 1; i < allSubInstancesArrays.length; i++) {
            // Go through the rest of subArrays and check if this sub exists in one of them
            if (allSubInstancesArrays[i].some((el) => el.id == sub.id)) {
              isCommonSub = true;
              break; // finding one subInstancesArray with a common subInstnace is enough so break the loop
            }
          }
          if (isCommonSub && commonSubs.every((el) => el.id != sub.id))
            // If is common & not already in commonSubs[] -> leave it in the array else remove it
            return true;
          else return false;
        });
        commonSubs = commonSubs.concat(filtered);
      });
      return commonSubs;
    },
    selectMergableInstance(mergable) {
      if (!mergable.checked) this.noInstancesSelected = false;
      else if (
        mergable.checked &&
        this.mergeTargets.every((el) => el.id == mergable.id || !el.checked)
      ) {
        // if unchecking an item and all other items are unchecked, show warning message
        this.noInstancesSelected = true;
      }
      mergable.checked = !mergable.checked;

      if (!this.mergePanelInitialInteraction)
        this.mergePanelInitialInteraction = true;
    },
    openMergePanel(id) {
      this.customMergeName = null;
      this.mergePanelInitialInteraction = false;

      this.autoGenerateName = true;
      if (this.$vuetify.breakpoint.xsOnly) {
        this.currentTabItem.showMergeTabMobile = true;
        this.filterMergeTargets(id);
        this.hideSeperatedInstances = false;
      } else {
        this.filterMergeTargets(id);
        this.hideSeperatedInstances = false;
        this.toggleMergeTab(id);
      }
    },
    setDragTouchListeners() {
      if (this.isNotDesktop)
        var resizeAreas = document.querySelectorAll(".drag_thumb");
      else
        var resizeAreas = document.querySelectorAll(
          "div.draggable div.ag-body-viewport"
        );

      if (resizeAreas.length > 0) {
        if (this.isNotDesktop) {
          // Mobile
          resizeAreas.forEach((el) => {
            el.addEventListener(
              "touchend",
              function (e) {
                parent.updateAppStateRemotelyAndLocally();
              },
              false
            );
          });
        } else {
          // Desktop
          resizeAreas.forEach((el) => {
            el.addEventListener(
              "mouseup",
              function (e) {
                parent.updateAppStateRemotelyAndLocally();
              },
              false
            );
          });
        }
      }
    },
    setResizeTouchListeners() {
      var resizeAreas = document.querySelectorAll(
        "div.draggable span.vue-resizable-handle"
      );

      if (resizeAreas.length > 0) {
        resizeAreas.forEach((el) => {
          el.addEventListener(
            "touchend",
            function (e) {
              parent.tableStateChange("touchend");
            },
            false
          );
        });
      }
    },
    reRenderErrorMessage() {
      this.resetErrorMessage = !this.resetErrorMessage;
      this.resetErrorMessage = !this.resetErrorMessage;
    },
    reRenderTabsBar() {
      this.vTabRenderKey < 100
        ? this.vTabRenderKey++
        : (this.vTabRenderKey = 0);
    },
    showSummaryFooter() {
      this.showingSummaryFooter = !this.showingSummaryFooter;
      this.emitSettingsUpdateToApp({
        section: APP_STATE_SECTIONS.ANALYTICS,
        innerSection: "showingSummaryFooter",
        mutation: this.showingSummaryFooter,
      });
    },
    showExposureTable() {
      this.showingExposureTable = !this.showingExposureTable;
      this.emitSettingsUpdateToApp({
        section: APP_STATE_SECTIONS.ANALYTICS,
        innerSection: "showingExposureTable",
        mutation: this.showingExposureTable,
      });
      if (!this.showingExposureTable) return;

      this.currentlyLoadingDataFor = this.currentTabItem.id;

      if (this.currentTabItem.mergedInstance) {
        // Each subinstance will be check for status (if is running) inside of fetchAndSetMergedTableData
        this.fetchAndSetMergedTableData(true);
      } else if (
        this.getEnabledApplicationInstances.length &&
        this.currentTabItem.appStatus == "RUN" &&
        this.currentTabItem.serverStatus == "CONNECTED"
      ) {
        this.fetchAndSetTableData(true);
      }
    },
    freezeInstance(instanceConfig) {
      if (
        !instanceConfig.hasOwnProperty("freezeAnalytics") ||
        !instanceConfig.freezeAnalytics
      ) {
        instanceConfig.freezeAnalytics = true;
        this.reRenderErrorMessage();
      }
    },
    unfreezeInstance(instanceConfig) {
      if (
        instanceConfig.hasOwnProperty("freezeAnalytics") &&
        instanceConfig.freezeAnalytics
      ) {
        instanceConfig.freezeAnalytics = false;
        this.reRenderErrorMessage();
      }
    },
    getInCompatibleInstances(id) {
      return this.fetchAnalyticInstancesFiltered.reduce((final, next) => {
        if (!this.instancesCompatible(next.id, id)) {
          let nextNoRef = JSON.parse(JSON.stringify(next));

          nextNoRef.incomp = true;
          final.push(nextNoRef);
        }
        return final;
      }, []);
    },
    removeInstanceDataFromDB(id) {
      localForage.removeItem("AN-data-" + id + "PositionsSummary", (err) => {
        if (err != null)
          console.error(
            `Couldn't remove item ${id + "PositionsSummary"} from IndexedDB`
          );
      });
      localForage.removeItem("AN-data-" + id + "PositionsExposure", (err) => {
        if (err != null)
          console.error(
            `Couldn't remove item ${id + "PositionsExposure"} from IndexedDB`
          );
      });
    },
    tableStateChange(ev, tableId = null, eventName, tableType = null) {
      // return in case if drag & drop event was triggered by range selction
      let eventIsAnObject = typeof ev == "object";

      if (
        eventIsAnObject &&
        ev.hasOwnProperty("target") &&
        ev.target.className &&
        ev.target.className == "ag-center-cols-container"
      )
        return;
      // if event was triggered by sizeColumnsToFit return because it was programmatically triggered
      if (eventIsAnObject && ev.source == "sizeColumnsToFit") return;

      this.gridResized(ev, tableId);

      if (
        eventIsAnObject &&
        ev.hasOwnProperty("source") &&
        ev.type == "columnVisible"
      ) {
        // If a columnVisible event fired from grid, make sure that it wasnt fired programmatically(api) and continue
        if (ev.source != "uiColumnDragged") {
          if (!(tableId != null && this.saveStateByApiAllowed)) {
            return;
          }
        }
      }

      if (
        eventIsAnObject &&
        ev.hasOwnProperty("source") &&
        ev.type == "columnRowGroupChanged"
      ) {
        if (ev.source != "toolPanelUi") {
          if (!(tableId != null && this.saveStateByApiAllowed)) {
            return;
          }
        }
      }

      let sectionModified = ev == "onmouseup" ? "layout" : null;

      this.updateAppStateRemotelyAndLocally({
        setDefaultTabState: false,
        sectionModified: sectionModified,
        tableType: tableType,
      });
    },
    removeMergedInstancesFromSaved(freshData) {
      // Remove all merged instances where both subinstances were terminated
      let mergedItemsToRemove = [];

      this.mergedInstances.forEach((merged) => {
        if (
          merged.subinstances.every(
            (
              sub // if all subinstances are terminated/do not exist then delete the merged instance
            ) => freshData.every((fresh) => fresh.id != sub.id)
          )
        ) {
          mergedItemsToRemove.push(merged.id);
        }
      });
      if (mergedItemsToRemove.length) {
        mergedItemsToRemove.forEach((el) =>
          this.destroyMergedInstance(el, true)
        );
      }
      this.focusOnTheRightTab();
    },
    handleFetchedApplicationInstances() {
      if (
        this.incompatibleInstances.length ||
        this.subinstancesRemoved.length
      ) {
        // Show user that incompatible instances were lost (but only if at least one of their subinstance exists in getEnabledApplicationInstances)
        let showMergedLost = false,
          showSubinstLost = false,
          configsDeletedLength = 0;

        for (var i = 0; i < this.getEnabledApplicationInstances.length; i++) {
          let el = this.getEnabledApplicationInstances[i];

          if (
            this.incompatibleInstances.some((incomp) => {
              if (incomp.length > 1)
                return incomp[0].id == el.id || incomp[1].id == el.id;
              else return incomp[0].id == el.id;
            })
          ) {
            showMergedLost = true;
            break;
          } else if (
            this.subinstancesRemoved.some((subInst) => {
              if (subInst == undefined) configsDeletedLength++;
              return subInst == el.id;
            })
          ) {
            showSubinstLost = true;
          }
        }

        if (showMergedLost) {
          this.$notifier.error(
            "Some merged instances were lost due to summary incompatibility",
            {
              link: "http://dealio.ai/docs/en/ui/analytics#incompatibilities--auto-removal",
            }
          );
        } else if (
          showSubinstLost &&
          configsDeletedLength != this.subinstancesRemoved.length
        )
          this.$notifier.error(
            "Some subinstances were removed due to summary incompatibility",
            {
              link: "http://dealio.ai/docs/en/ui/analytics#incompatibilities--auto-removal",
            }
          );
      }

      if (this.savedSelectedTabId != null) {
        let itemIndex = 0;
        let findItem = this.analyticInstances.find((el, index) => {
          if (el.id == this.savedSelectedTabId) {
            itemIndex = index;
            return true;
          } else return false;
        });
        if (findItem != undefined) {
          this.addItem(
            { mobileModel: false, showMergeTabMobile: false, ...findItem },
            itemIndex,
            false
          );
        } else {
          this.addItem(
            {
              mobileModel: false,
              showMergeTabMobile: false,
              ...this.analyticInstances[0],
            },
            0,
            false
          );
        }
      } else {
        this.addItem(
          {
            mobileModel: false,
            showMergeTabMobile: false,
            ...this.analyticInstances[0],
          },
          0,
          false
        );
      }

      if (this.grids == null) this.grids = {};
      let grids = this.grids;
      this.fetchAnalyticInstancesFiltered.forEach(function (instance) {
        grids[instance.id] = {
          name: instance.name,
          summary: {
            gridOptions: {},
            getRowNodeId: null,
          },
          exposure: {
            gridOptions: {},
            getRowNodeId: null,
          },
        };
      });
      this.loading = false;
    },
    loadPageState() {
      let outdatedVuexData = false;

      let settings = JSON.parse(
        JSON.stringify(
          this.getSpecificSetting({
            section: "applicationState",
            innerSection: "analytics",
          })
        )
      );

      if (settings.instances.length || settings.mergedInstances.length) {
        settings.mergedInstances.forEach((inst) => {
          // restore compatible merged instances

          if (this.outdatedVersionData(inst.name)) {
            if (!outdatedVuexData) outdatedVuexData = true;
            return;
          }

          let compatibleSubs = inst.subinstances.filter((el) => {
            let groupBySymbol = this.isGoupedBySymbol(el);

            if (
              groupBySymbol == undefined ||
              groupBySymbol != inst.groupBySymbol
            ) {
              if (groupBySymbol == undefined)
                this.subinstancesRemoved.push(undefined);
              else if (
                !this.subinstancesRemoved.some((subInst) => subInst == el.id)
              ) {
                this.subinstancesRemoved.push(el.id);
              }
              return false;
            } else {
              return true;
            }
          });

          let cleanInst = JSON.parse(JSON.stringify(inst));

          if (compatibleSubs.length != inst.subinstances.length) {
            cleanInst.subinstances = compatibleSubs;
          }
          if (compatibleSubs.length) this.mergedInstances.push(cleanInst);
          else {
            this.incompatibleInstances.push(
              JSON.parse(JSON.stringify(inst.subinstances))
            );
          }
        });

        this.removeIncompatiblesData();

        if (this.subinstancesRemoved.length || outdatedVuexData) {
          // Update Vuex if you modified subInstances
          // this.updateMergedInstancesState();

          this.emitSettingsUpdateToApp({
            section: APP_STATE_SECTIONS.ANALYTICS,
            innerSection: "mergedInstances",
            mutation: JSON.parse(JSON.stringify(this.mergedInstances)),
          });
        }

        if (this.mergedInstances.length) this.createMergedInstancesGrids();

        this.instances = JSON.parse(JSON.stringify(settings.instances));
      }
      if (settings.selectedInstance != null)
        this.savedSelectedTabId = settings.selectedInstance;

      if (settings.hasOwnProperty("showingExposureTable"))
        this.showingExposureTable = settings.showingExposureTable;

      if (settings.hasOwnProperty("showingSummaryFooter"))
        this.showingSummaryFooter = settings.showingSummaryFooter;

      // When page is reloaded the instances are fetched within the App.vue
      this.fetchApplicationInstances() // initial fetch of application instances
        .then(() => {
          this.handleFetchedApplicationInstances();
          this.calculateMergedInstancesInfo();

          if (this.currentTabItem.mergedInstance) {
            // Each subinstance will be check for status (if is running) inside of fetchAndSetMergedTableData
            this.fetchAndSetMergedTableData();
          } else if (
            this.getEnabledApplicationInstances.length &&
            this.currentTabItem.appStatus == "RUN" &&
            this.currentTabItem.serverStatus == "CONNECTED"
          ) {
            this.fetchAndSetTableData();
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });

      this.vuexIsLoading = false;
    },
    instancesCompatible(id1, id2) {
      let id1Config = this.ANInstanceConfigs.find((el) => el.id == id1);
      let id2Config = this.ANInstanceConfigs.find((el) => el.id == id2);
      return id1Config.groupBySymbol == id2Config.groupBySymbol;
    },
    destroyMergedInstance(
      id,
      isMerged = false,
      hideSeperated = false,
      removeManually = false
    ) {
      // Destroy & remove merged instance from both UI and DB
      // hideSeperated is true when the instance passed in this function is a seperated instance & its' parent (mergedInstance) has hideSeperated = true
      if (isMerged) {
        let mergedInst = this.mergedInstances.find((el) => el.id == id);

        // In case this merged instance was not found -> return to avoid any errors
        if (!mergedInst) return;

        if (
          mergedInst.hasOwnProperty("hideSeperated") &&
          mergedInst.hideSeperated
        ) {
          // since hidden instances now will be shown -> they need to exist in this.instances and this.mergeTabs
          let mergeTabs = JSON.parse(JSON.stringify(this.mergeTabs));
          mergedInst.subinstances.forEach((el) => {
            this.addNewInstance(el.id);
            mergeTabs[el.id] = {
              model: false,
              showMergeTab: false,
              openOnHover: true,
            };
          });
          this.mergeTabs = Object.assign({}, mergeTabs);
        }
        this.mergedInstances = this.mergedInstances.filter((el) => el.id != id);
        mergedInst.subinstances.forEach((el) => {
          // remove useless instances Data from IndexedDB
          let subinstanceDataNeeded = this.mergedInstances.some((Minst) => {
            // Its' IndexedDB data is needed if there is another merged instance with this subinstance as it's child
            if (Minst.subinstances.some((sub) => sub.id == el)) return true;
            else return false;
          });
          if (!subinstanceDataNeeded) {
            this.removeInstanceDataFromDB(el.id);
          }
        });
        this.closeAllMenus();
      }
      if (this.mergeTabs[id] != undefined) delete this.mergeTabs[id];
      this.instances = this.instances.filter((el) => el.id != id);
      // TODO:
      // something wrong with this IF statement

      if (!hideSeperated) {
        // if the instance is being remove because of 'hideSeperated' then there is no point of deleting its state. This argument is for seperated instances only
        // let pageState = this.getSpecificSetting({
        //     section: "applicationState",
        //     innerSection: "analytics",
        //   })

        let deselectTab = false;
        if (
          this.currentTabItem.hasOwnProperty("id") &&
          this.currentTabItem.id == id
        ) {
          deselectTab = true;
        }

        // The following (updatePageState) removes the instance with "id"
        // from instances && mergedInstances in vuex-pageStates
        // this.updatePageState({
        //   id: id,
        //   page: "analytics",
        //   action: "remove-merged-instance",
        //   deselectTab: deselectTab
        // });

        this.updateAppStateRemotelyAndLocally({
          action: this.MERGED_ACTIONS.DESTROY,
          actionOptions: { instanceId: id },
        });
      }
      if (id == this.currentTabItem.id) {
        let item = this.analyticInstances[this.analyticInstances.length - 1];
        let index = this.analyticInstances.length - 1;
        this.addItem(item, index, false, true);
      } else {
        this.reRenderTabsBar(); // rerendering tabs is needed because the indexes change so the worng tab might be shown
      }
    },
    createMergedInstancesGrids() {
      this.mergedInstances.forEach((el) => {
        if (this.grids == null) this.grids = {};
        this.grids[el.id] = {
          name: [el.name[0], el.name[1]], // user only primitive data types
          summary: {
            gridOptions: {},
            getRowNodeId: null,
          },
          exposure: {
            gridOptions: {},
            getRowNodeId: null,
          },
        };
      });
    },
    addServerProperty(data, serverName) {
      return data.map((el) => {
        if (el.length) el.push(serverName);
        else el.instanceId = serverName;
        return el;
      });
    },
    // DESCRIPTION: Update cached data -> merge data -> Update grid
    // WORKFLOW: 1. Filter merged instances to update
    // 2. Update the cached data for the specific server
    // 3. ...
    async mergeDataAndUpdateGrid(newDataServerId, table, data) {
      let instanceToUpdate = this.currentTabItem.subinstances.find(
        (el) => el.id == newDataServerId
      );
      let serverName;
      if (instanceToUpdate) serverName = instanceToUpdate.name;
      else return;

      data = this.addServerProperty(data, serverName);

      localForage.setItem(
        "AN-data-" + newDataServerId + table,
        data,
        async (setErr) => {
          if (setErr == null) {
            let mergedData = [];
            for (const subinstance of this.currentTabItem.subinstances) {
              if (subinstance.id == newDataServerId) {
                mergedData = mergedData.concat(data);
              } else {
                await localForage
                  .getItem("AN-data-" + subinstance.id + table)
                  .then((cachedData) => {
                    if (cachedData != null && cachedData.length) {
                      mergedData = mergedData.concat(cachedData);
                    }
                  })
                  .catch((err) => {
                    this.$notifier.warn(
                      "Something went wrong please reload this page"
                    );
                  });
              }
            }
            this.updateGridData(mergedData, this.currentTabItem.id, table);
          } else {
            console.error(err);
            this.$notifier.error(
              "Oops! Something went wrong. Please reload this page"
            );
          }
        }
      );
    },
    // DESCRIPTION: Update grid data of a simple instance (summary or exposure)
    updateGridData(data, serverId, source) {
      try {
        if (
          this.grids[serverId] &&
          this.grids[serverId].summary.gridOptions.hasOwnProperty("api") &&
          this.grids[serverId].summary.gridOptions.api != null
        ) {
          if (source === "PositionsSummary") {
            this.grids[serverId].summary.gridOptions.api.setRowData(data);

            if (data.length) {
              let numericData = this.isNumeric(data[0]);
              let configID;
              if (typeof serverId == "string" && serverId.includes("-")) {
                configID = serverId.split("-")[0];
              } else configID = serverId;
              let groupedBySymbol = this.isGoupedBySymbol({ id: configID });

              if (numericData && groupedBySymbol !== undefined) {
                this.updateTotals(serverId, data, groupedBySymbol);
              } else this.updateTotals(serverId, data);
            }
          } else if (this.showingExposureTable) {
            this.grids[serverId].exposure.gridOptions.api.setRowData(data);
          }
          // else {
          //   data = null;
          // }
        }
        // else {
        //   data = null;
        // }
      } catch (exception) {
        console.error(exception);
      }
    },
    refreshMergedInstances(freshData) {
      // removing terminated merged instances & updating statuses of merged instances
      this.removeMergedInstancesFromSaved(freshData); // remove terminated merged instances from state,indexeddb,mergedInstances etc.
    },
    isFrozen(newItemID) {
      let config = this.ANInstanceConfigs.find((el) => {
        return el.id == newItemID;
      });
      return config.hasOwnProperty("freezeAnalytics")
        ? config.freezeAnalytics
        : false;
    },
    toggleAddMoreInstancesTab(id) {
      let mergedInst = this.mergedInstances.find((el) => el.id == id);

      mergedInst.availableInstances = this.getAvailableInstances(
        mergedInst.subinstances,
        mergedInst.groupBySymbol
      );

      if (this.$vuetify.breakpoint.xsOnly) {
        // Since on mobile only one mergedInstance name is showed and it is showed using currentTabItem
        this.currentTabItem.availableInstances = JSON.parse(
          JSON.stringify(mergedInst.availableInstances)
        );
      }

      if (!this.mergeTabs[id].addInstancesSelector)
        this.mergeTabs[id].openOnHover = false;
      else this.mergeTabs[id].openOnHover = true;
    },
    toggleMergeTab(id, closeModel) {
      Object.keys(this.mergeTabs).forEach((tabId) => {
        // When "merge" button is clicked, openOnHover of rest of mergeTabs should become true
        if (tabId != id) {
          setTimeout(() => {
            this.mergeTabs[tabId].showMergeTab = false;
          }, 150);
          this.mergeTabs[tabId].openOnHover = true;
        } else {
          if (closeModel)
            this.mergeTabs[tabId].model = !this.mergeTabs[tabId].model;
          this.mergeTabs[tabId].showMergeTab = true;
          this.mergeTabs[tabId].openOnHover = false;
        }
      });
    },
    mergeInstances(source) {
      let selectedMergeTargets = this.mergeTargets.filter((el) => el.checked);

      let mergedId = this.getUniqueMergedId(selectedMergeTargets, source);

      let name =
        !this.autoGenerateName && this.customMergeName
          ? this.customMergeName
          : `Merged Instance ${this.mergedInstances.length + 1}`;

      this.grids[mergedId] = {
        // add new grid (summary and exposure tables)
        name: name,
        summary: {
          gridOptions: {},
          getRowNodeId: null,
        },
        exposure: {
          gridOptions: {},
          getRowNodeId: null,
        },
      };
      if (this.instances.find((el) => el.id == mergedId) == undefined) {
        // add a new instance to this.instances (for retreiving tables layout)
        this.addNewInstance(mergedId);
      }
      let mergeTabs = JSON.parse(JSON.stringify(this.mergeTabs)); // add a new mergeTab
      mergeTabs[mergedId] = {
        model: false,
        showMergeTab: false,
        openOnHover: true,
        addInstancesSelector: false,
      };
      this.mergeTabs = Object.assign({}, mergeTabs);

      let subinstances = [
        {
          name: source.name,
          id: source.id,
        },
        ...selectedMergeTargets.reduce((final, next) => {
          let newItem = {
            name: next.name,
            id: next.id,
          };
          return [...final, newItem];
        }, []),
      ];
      let groupBySymbol = this.getInstanceSetting(
        subinstances[0]
      ).groupBySymbol;

      this.mergedInstances.push(
        // add to mergedInstances used in analyticInstances() (fetched instances + merged instances)
        {
          name: name,
          subinstances: subinstances,
          id: mergedId,
          hideSeperated: this.hideSeperatedInstances,
          groupBySymbol: groupBySymbol, // get groupBySymbol of the first subinstance since for them to be selected means all their configs match
          mergedInstance: true,
          availableInstances: this.getAvailableInstances(
            subinstances,
            groupBySymbol
          ),
          addInstancesSelectorModel: false,
        }
      );

      let focusOnAnotherTab = true; // TO BE REFACTORED
      if (this.hideSeperatedInstances) {
        // should be after mergedInstances.push so that they(source&target) are firstly removed from the dom

        if (
          selectedMergeTargets.some(
            (target) => target.id == this.currentTabItem.id
          )
        ) {
          // no need to focus on anotherTabItem since it will be done in destroyMergedInstances() // TO BE REFACTORED
          focusOnAnotherTab = false;
        }

        subinstances.forEach((subInst) => {
          this.destroyMergedInstance(subInst.id, false, true); // Remove(hide) instances that should be hidden
        });
      }

      this.mergeTarget = null; // clear merge v-select
      this.hideSeperatedInstances = false; // default hideSeperatedInstances
      this.toggleMergeTab(source.id, true); // close the merge panel
      let tabIndex = this.analyticInstances.length - 1; // focus on the newly added tab
      let item = {
        mobileModel: false,
        showMergeTabMobile: false,
        ...this.analyticInstances[this.analyticInstances.length - 1],
      };

      if (!this.hideSeperatedInstances && focusOnAnotherTab) {
        this.addItem(item, tabIndex, false, true);
      }

      this.updateAppStateRemotelyAndLocally({
        setDefaultTabState: true,
        sectionModified: null,
        tableType: null,
      }); // save new merged item to state

      if (this.$vuetify.breakpoint.xsOnly) {
        this.currentTabItem.mobileModel = false;
        this.currentTabItem.showMergeTabMobile = false;
      }
    },
    filterMergeTargets(id) {
      let incompatibles = this.getInCompatibleInstances(id);

      let fetchedInstancesNoRef = JSON.parse(
        JSON.stringify(this.fetchAnalyticInstancesFiltered)
      );
      let items = fetchedInstancesNoRef.reduce((final, next) => {
        // return items that are compatible & is not this(id) instance
        let notCurrent = next.id != id;
        let compatible = !incompatibles.some((inc) => inc.id == next.id);

        if (
          // notOccupied && // Not logical now that we have multiple instances
          notCurrent &&
          compatible
        ) {
          next.checked = false;
          final.push(next);
        }
        return final;
      }, []);
      this.mergeTargets = items;
    },
    removeOldGrids() {
      let oldInstances = this.analyticInstancesInitialLoadedValues.filter(
        (ins) =>
          this.fetchAnalyticInstancesFiltered.every(
            (loadedV) => loadedV.id != ins.id
          )
      );
      oldInstances.forEach((instance) => {
        if (this.grids[instance.id]) delete this.grids[instance.id];
      });
    },
    addNewGrids() {
      let newInstances = this.fetchAnalyticInstancesFiltered.filter((ins) =>
        this.analyticInstancesInitialLoadedValues.every(
          (loadedV) => loadedV.id != ins.id
        )
      );
      newInstances.forEach((instance) => {
        this.grids[instance.id] = {
          name: instance.name,
          summary: {
            gridOptions: {},
            getRowNodeId: null,
          },
          exposure: {
            gridOptions: {},
            getRowNodeId: null,
          },
        };
      });
      this.addingNewGrid = false;
    },
    getInstanceSetting(instance) {
      let instanceConfig = this.ANInstanceConfigs.find((el) => {
        return el.id == instance.id;
      });
      if (!instanceConfig.hasOwnProperty("freezeAnalytics"))
        return { freezeAnalytics: false, ...instanceConfig };
      else return instanceConfig;
    },
    checkConfigAndDataMatch(message, newItemID, numericData) {
      let instanceConfig = this.ANInstanceConfigs.find((el) => {
        return el.id == newItemID;
      });

      if (!instanceConfig) return;

      if (instanceConfig.groupBySymbol) {
        // Data should be unfolded
        if (
          (numericData && message[2][0].length == 16) ||
          (message.data && message.data[0].hasOwnProperty("PositionId"))
        ) {
          // Data is unfolded
          // Each data set ends up here if instance configs do not match the instance data (until the reload happens)
          this.freezeInstance(instanceConfig);

          // If this is not the first check after page reload then reload the page
          if (instanceConfig.gotFirstSummaryData && !this.reloadingAN) {
            this.reloadingAN = true;
            this.$notifier.warn(
              "Some analytics configurations were changed reloading dealio in a few seconds.."
            );
            setTimeout(() => {
              window.location.reload();
            }, 6000);
          }
        } else {
          if (instanceConfig.gotFirstSummaryData == undefined)
            instanceConfig.gotFirstSummaryData = true;
          this.unfreezeInstance(instanceConfig);
        }
      } else {
        // Data should be folded
        if (
          (numericData && message[2][0].length != 16) ||
          (message.data && !message.data[0].hasOwnProperty("PositionId"))
        ) {
          // Data is folded
          this.freezeInstance(instanceConfig);

          if (instanceConfig.gotFirstSummaryData && !this.reloadingAN) {
            this.reloadingAN = true;
            this.$notifier.warn(
              "Some analytics configurations were changed reloading dealio in a few seconds.."
            );
            setTimeout(() => {
              window.location.reload();
            }, 6000);
          }
        } else {
          if (instanceConfig.gotFirstSummaryData == undefined)
            instanceConfig.gotFirstSummaryData = true;
          this.unfreezeInstance(instanceConfig);
        }
      }
    },
    reloadPage() {
      window.location.reload();
    },
    summaryColumnDefs(instance) {
      let numericData;
      // if (!instance.mergedInstance) {
      let instanceConfig = this.getInstanceSetting(
        instance.mergedInstance ? instance.subinstances[0] : instance
      );
      numericData = instanceConfig.MinifyMessages;
      // }
      if (instance.mergedInstance) {
        if (instance.groupBySymbol) {
          if (numericData) return summaryColumnDefsFoldedNumericMerged;
          return summaryColumnDefsFoldedMerged;
        } else {
          if (numericData) return summaryColumnDefsUnfoldedNumericMerged;
          return summaryColumnDefsUnfoldedMerged;
        }
      } else if (this.isGoupedBySymbol(instance)) {
        return numericData
          ? summaryColumnDefsFoldedNumeric
          : summaryColumnDefsFolded;
      } else {
        return numericData
          ? summaryColumnDefsUnfoldedNumeric
          : summaryColumnDefsUnfolded;
      }
    },
    isGoupedBySymbol(instance) {
      let inst = this.ANInstanceConfigs.find((el) => el.id == instance.id);
      if (inst) return inst.groupBySymbol;
      else return undefined;
    },
    getANInstanceConfigs() {
      this.error = false;
      let params = {
        page: 0,
        size: 9999,
      };
      ApplicationDefinitionService.query({ params: params })
        // ApplicationDefinitionService.get()
        .then((r) => {
          try {
            // this.ANInstanceConfigs = r.data.reduce((filtered, el) => {
            this.ANInstanceConfigs = r.data.content.reduce((filtered, el) => {
              let configuration = JSON.parse(el.configuration);
              if (configuration.hasOwnProperty("Analytics")) {
                filtered.push({
                  id: el.id,
                  groupBySymbol:
                    configuration.Analytics.GroupSummaryItemsBySymbol,
                  Enabled: configuration.Analytics.Enabled,
                  name: el.name,
                  MinifyMessages: configuration.Analytics.MinifyMessages,
                });
              }
              return filtered;
            }, []);
          } catch (exception) {
            this.errorMessage = "Something went wrong";
            this.error = true;
            console.error(exception);
            return;
          }

          this.loadPageState();
          this.loadingConfigurations = false;
        })
        .catch((er) => {
          this.errorMessage = er.message;
          this.error = true;
          this.loadingConfigurations = false;
          console.error(er);
        });
    },
    updateTotals(serverId, messageData, groupedBySymbol = null) {
      let numericData = this.isNumeric(messageData[0]);
      let totals;

      if (numericData) {
        if (groupedBySymbol != null)
          totals = [this.getNumericDataTotals(messageData, groupedBySymbol)];
        else totals = [this.getNumericDataTotals(messageData)];
      } else {
        totals = [this.getJSONDataTotals(messageData)];
      }

      if (numericData) {
        totals[0][0] = " ";
        totals[0][1] = " ";
        totals[0][4] = " ";
        totals[0][6] = " ";
        totals[0][11] = " ";
      } else {
        totals[0].Symbol = " ";
        totals[0].PlainSymbol = " ";
        totals[0].BuyPrice = " ";
        totals[0].SellPrice = " ";
        totals[0].Book = " ";
      }

      let indexOfItem = this.pinnedBottomRowData.findIndex((el) => {
        return el.serverId == serverId;
      });
      if (this.pinnedBottomRowData.length && indexOfItem != -1) {
        this.temporaryVar++;
        this.pinnedBottomRowData[indexOfItem].totals = totals;
      } else {
        this.pinnedBottomRowData.push({
          serverId: serverId,
          totals: totals,
        });
      }
    },
    resetColumnState() {
      this.saveStateByApiAllowed = true;
      setTimeout(() => {
        // Allow saving states on ag-grid API columnVisible event for 0.5s (which is enough time to reset grid the grid & fire state saving events)
        if (this.saveStateByApiAllowed) this.saveStateByApiAllowed = false;
      }, 500);

      let summary = this.grids[this.currentTabItem.id].summary;

      summary.gridOptions.columnApi.resetColumnState();

      this.fixWrongGroupingColumnPlacement(summary);

      if (this.showingExposureTable) {
        let exposure = this.grids[this.currentTabItem.id].exposure;
        exposure.gridOptions.columnApi.resetColumnState();

        this.fixWrongGroupingColumnPlacement(exposure);
      }

      this.fitColumns("resetColumnState");
    },
    removeInstanceFromSaved(itemsToRemove) {
      itemsToRemove.forEach((el) => this.destroyMergedInstance(el.id));

      this.focusOnTheRightTab();
    },
    addNewInstance(id) {
      let item = defaultANStateInstance.setInstance(id);
      this.instances.push(item);
    },
    getLayout(id) {
      let layout = this.instances.find((el) => el.id == id).layout;
      if (!this.showingExposureTable) layout = [layout[0]];
      return layout;
    },
    addItem(
      item,
      index,
      saveState = true,
      reRenderTabsBar = false,
      updateCurrentTabItem = true
    ) {
      // In case the user clicks an already selected tab -> return;
      if (this.tabs == index && this.currentTabItem.id == item.id) return;

      this.tabs = index;

      // updateCurrentTabItem == true means that the instead of just focusing on the right tab
      // the program should also fetch the latest data for the tables in that tab
      if (updateCurrentTabItem) {
        this.currentlyLoadingDataFor = item.id;

        var previousTabId = this.currentTabItem.id;

        this.currentTabItem = Object.assign(
          {
            mobileModel: false,
            showMergeTabMobile: false,
          },
          item
        );

        // Clear the previous table data
        if (previousTabId != -1) {
          if (this.currentTabItem.mergedInstance) {
            // Each subinstance will be check for status (if is running) inside of fetchAndSetMergedTableData
            this.fetchAndSetMergedTableData();
          } else if (
            this.currentTabItem.appStatus == "RUN" &&
            this.currentTabItem.serverStatus == "CONNECTED"
          ) {
            this.fetchAndSetTableData();
          }
        }
        // Used to ignore the unwanted sse data
        let currentTableAgentIds = this.currentTabItem.mergedInstance
          ? this.currentTabItem.subinstances.map((el) => el.id)
          : [this.currentTabItem.id];
        this.$emit(
          "analytics-tab-change",
          JSON.parse(JSON.stringify(currentTableAgentIds))
        );
      }

      if (reRenderTabsBar) this.reRenderTabsBar();
      if (saveState) {
        this.emitSettingsUpdateToApp({
          section: APP_STATE_SECTIONS.ANALYTICS,
          innerSection: "selectedInstance",
          mutation: item.id,
        });
      }

      // TODO
      // if previousTabId was a merged instance then delete its' sunsinstances data from localForage
      if (updateCurrentTabItem && previousTabId != this.currentTabItem.id)
        this.clearUnfocusedTable(previousTabId);
    },
    groupRowAggNodes(nodes) {
      if (!nodes.length) {
        return {};
      }

      let numericData = this.isNumeric(
        nodes[0].group ? nodes[0].aggData : nodes[0].data
      );

      let keys;
      if (numericData) {
        keys = ANPositionKeys.numeric;
      } else {
        keys = ANPositionKeys.strings;
      }

      var result = numericData ? [] : {};

      var sumOfPrices = 0,
        sumOfSells = 0,
        totalSellVolume = 0,
        totalBuyVolume = 0,
        PlainSymbol = null,
        Digits = null,
        totalDeals = 0,
        totalNetVolume = 0,
        totalNotionalValue = 0,
        totalProfit = 0,
        totalCommision = 0,
        totalSwap = 0,
        Book = null;

      nodes.forEach((node) => {
        if (node.hasOwnProperty("data") || node.hasOwnProperty("aggData")) {
          var data = node.group ? node.aggData : node.data;

          sumOfPrices += data[keys.BuyPrice] * data[keys.BuyVolume];
          sumOfSells += data[keys.SellPrice] * data[keys.SellVolume];
          totalBuyVolume += data[keys.BuyVolume];
          totalSellVolume += data[keys.SellVolume];

          if (PlainSymbol == null) PlainSymbol = data[keys.PlainSymbol];
          if (Digits == null) Digits = data[keys.Digits];

          totalDeals += data[keys.Count];
          totalNetVolume += data[keys.NetVolume];
          totalNotionalValue += data[keys.NotionalValue];
          totalProfit += data[keys.Profit];
          totalCommision += data[keys.Commision];
          totalSwap += data[keys.Swap];
          Book == null
            ? node.hasOwnProperty("aggData")
              ? (Book = data[keys.Book])
              : (Book = Book)
            : (Book = Book);
        }
      });
      if (nodes.length) {
        if (nodes[0].group) {
          result[keys.BuyPrice] = " ";
          result[keys.SellPrice] = " ";
        } else {
          result[keys.BuyPrice] =
            totalBuyVolume == 0 ? 0 : sumOfPrices / totalBuyVolume;
          result[keys.SellPrice] =
            totalSellVolume == 0 ? 0 : sumOfSells / totalSellVolume;
        }
      } else {
        result[keys.BuyPrice] =
          totalBuyVolume == 0 ? 0 : sumOfPrices / totalBuyVolume;
        result[keys.SellPrice] =
          totalSellVolume == 0 ? 0 : sumOfSells / totalSellVolume;
      }
      if (nodes.length == 1) {
        result[keys.Symbol] = PlainSymbol;
        result[keys.PlainSymbol] = PlainSymbol;
      } else result[keys.Symbol] = null;

      result[keys.Digits] = Digits;
      result[keys.Count] = totalDeals;
      result[keys.BuyVolume] = totalBuyVolume;
      result[keys.SellVolume] = totalSellVolume;
      result[keys.NetVolume] = totalNetVolume;
      result[keys.NotionalValue] = totalNotionalValue;
      result[keys.Profit] = totalProfit;
      result[keys.Commision] = totalCommision;
      result[keys.Swap] = totalSwap;
      result[keys.Book] = Book;

      return result;
    },
    fitColumns(event, tablesToResize = { summary: true, exposure: true }) {
      if (this.$vuetify.breakpoint.width > 830) {
        let grids = this.grids[this.currentTabItem.id];
        if (grids.summary.gridOptions.hasOwnProperty("api")) {
          var summaryTablewidth, exposureTablewidth;
          this.getCurrentLayout.forEach((el) => {
            if (el.i == this.summaryTableId) {
              summaryTablewidth = el.w;
            } else if (el.i == this.exposureTableId) {
              exposureTablewidth = el.w;
            }
          });

          var summaryColumnsWidth = grids.summary.gridOptions.columnApi
            .getAllDisplayedColumns()
            .reduce((a, b) => {
              return b.colDef.headerName == "Group" ? a + 185 : a + 112;
            }, 0);

          if (
            (summaryTablewidth >= 18 ||
              summaryColumnsWidth < summaryTablewidth * 92 ||
              (this.getMiniDrawer &&
                summaryColumnsWidth < summaryTablewidth * 99)) &&
            tablesToResize.summary
          ) {
            if (this.$vuetify.breakpoint.width > 970) {
              grids.summary.gridOptions.api.sizeColumnsToFit();
            }
          }

          if (this.showingExposureTable && tablesToResize.exposure) {
            var exposureColumnsWidth = grids.exposure.gridOptions.columnApi
              .getAllDisplayedColumns()
              .reduce((a, b) => {
                return b.colDef.headerName == "Group" ? a + 205 : a + 122;
              }, 0);

            if (
              exposureTablewidth >= 9 ||
              exposureColumnsWidth < exposureTablewidth * 92 ||
              (this.getMiniDrawer && exposureTablewidth >= 8)
            ) {
              grids.exposure.gridOptions.api.sizeColumnsToFit();
            }
          }
        }
      }
    },
    rowExpanded(data) {
      this.fitColumns("row-group-opened");
    },
    getKey(id, index) {
      switch (id) {
        case "0":
          return index + 2;
        case "1":
          return index;
        default:
          return 0;
      }
    },
    getGroupRowAggNodes(itemId) {
      switch (itemId) {
        case "0":
          return this.groupRowAggNodes;
        case "1":
          return "";
        default:
          return 0;
      }
    },
    getGridOptions(itemId, instanceId) {
      switch (itemId) {
        case "0":
          return this.grids[instanceId].summary.gridOptions;
        case "1":
          return this.grids[instanceId].exposure.gridOptions;
        default:
          return 0;
      }
    },
    getColumnsDefs(LayoutId, instance) {
      switch (LayoutId) {
        case "0":
          return this.summaryColumnDefs(instance);
        case "1":
          let instanceConfig = this.getInstanceSetting(
            instance.mergedInstance ? instance.subinstances[0] : instance
          );
          let numericData = instanceConfig.MinifyMessages;

          if (numericData) {
            if (instance.mergedInstance) return exposureColumnDefsNumericMerged;
            else return exposureColumnDefsNumeric;
          } else {
            if (instance.mergedInstance) return exposureColumnDefsMerged;
            else return exposureColumnDefs;
          }
        default:
          return 0;
      }
    },
    copyRowData(data) {
      return data.map((datum) => {
        return {
          ...datum,
        };
      });
    },
    onGridReady(tableId) {
      if (this.isNotDesktop) {
        setTimeout(() => {
          this.setResizeTouchListeners(); // Only needed for touchscreen devices
        }, 1000);
      }

      if (this.getTableDragVModel) this.setDragTouchListeners(); // Needed for both touch and non-touch screen devices

      let grids = this.grids;
      let curInstance = this.instances.find(
        (inst) => inst.id == this.currentTabItem.id
      );

      let resizeColumnsToFitTable = { summary: true, exposure: true };

      if (
        curInstance != undefined && // curInstance is undefined for the new instances
        curInstance.hasOwnProperty("summary") &&
        curInstance.hasOwnProperty("exposure") &&
        curInstance.summary != undefined
      ) {
        if (
          Object.keys(curInstance.summary).length &&
          grids[this.currentTabItem.id].summary.gridOptions.hasOwnProperty(
            "columnDefs"
          )
        ) {
          //
          // if(current table width is the same as the saved one)
          resizeColumnsToFitTable.summary = curInstance.summary.every(
            (el) => el.width == null
          );

          grids[
            this.currentTabItem.id
          ].summary.gridOptions.columnApi.applyColumnState({
            state: curInstance.summary,
            applyOrder: true,
          });
        }

        if (
          Object.keys(curInstance.exposure).length &&
          grids[this.currentTabItem.id].exposure.gridOptions.hasOwnProperty(
            "columnDefs"
          ) &&
          this.showingExposureTable
        ) {
          resizeColumnsToFitTable.exposure = curInstance.summary.every(
            (el) => el.width == null
          );

          grids[
            this.currentTabItem.id
          ].exposure.gridOptions.columnApi.applyColumnState({
            state: curInstance.exposure,
            applyOrder: true,
          });
        }
      }
      if (resizeColumnsToFitTable)
        this.fitColumns("onGridReady", resizeColumnsToFitTable);
    },
    ...mapActions("instances", ["fetchApplicationInstances"]),
    // ...mapMutations(["updatePageState"]),
    ...mapMutations(["updateSpecificSetting"]),
  },
  beforeMount() {
    this.statusBar = { items: [{ component: "agAggregationComponent" }] };
    this.rowGroupPanelShow = "always";
    this.pivotPanelShow = "always";
    this.defaultColDef = {
      width: 100,
      sortable: true,
      resizable: true,
    };
    this.autoGroupColumnDef = { width: 200 };
    this.getRowNodeId = (data, instance) => {
      let numericData = Array.isArray(data);

      let finalId = "";
      //  Minified Messages
      if (numericData) {
        // Merged exposure table (unfolded)
        if (data.length == 17) finalId = data[16];
        // Merged exposure table (folded)
        else if (data.length == 16) finalId = data[15];

        if (
          data.length == 9 ||
          (data.length == 10 && instance.mergedInstance)
        ) {
          // Exposure
          finalId = data[0] + data[2];
        } else if (
          (data.length == 16 && !instance.mergedInstance) ||
          (data.length == 17 && instance.mergedInstance)
        ) {
          //  Is summary unfolded && not summary folded + merged (has length of 16)  is summary unfolded + merged instance
          // Summary(unfolded);
          finalId = data[13];
        } else {
          // Summary(folded);
          finalId = data[0] + data[14];
        }
      }
      //  Default JSON Messages
      else {
        if (data.length == 17) finalId = data[16];
        //  Merged summary table (folded)
        else if (instance.mergedInstance && data.length == 16)
          finalId = data[15];
        //  Merged table
        if (data.hasOwnProperty("instanceId"))
          finalId = finalId + data.instanceId;
        if (data.hasOwnProperty("Asset")) {
          //  Exposure
          finalId = data.Asset + data.MappingId;
        } else if (data.hasOwnProperty("PositionId")) {
          //  Summary (unfolded)
          finalId = data.PositionId;
        } else {
          //  Summary (folded)
          finalId = data.Symbol + data.MappingId;
        }
      }

      if (instance.mergedInstance) {
        if (numericData) {
          //  Merged, minified data
          finalId = finalId + data[data.length - 1];
        } else {
          //  Merged, normal JSON data
          finalId = finalId + data.instanceId;
        }
      }
      return finalId;
    };
    this.getRowStyle = (params) => {
      if (params.node.rowPinned) {
        return { "font-weight": "bold" };
      }
    };
  },
  mounted() {
    parent = this;

    document.body.onmousedown = function () {
      if (
        parent.instances != null &&
        parent.currentTabItem.id != -1 &&
        parent.currentTabItem.id &&
        parent.getCurrentLayout
      ) {
        parent.previousTablesSize = JSON.parse(
          JSON.stringify(parent.getCurrentLayout)
        );
        var x = event.clientX,
          y = event.clientY,
          elementMouseOver = document.elementFromPoint(x, y);

        if (elementMouseOver.className == "vue-resizable-handle") {
          this.resizingATableRightNow = true;
        }
      }
    };

    document.body.onmouseup = function () {
      if (this.resizingATableRightNow) {
        let idOfModifiedTable = parent.getIdOfModifiedTable();
        parent.tableStateChange("onmouseup", idOfModifiedTable, "onmouseup");
      }
      this.resizingATableRightNow ? (this.resizingATableRightNow = false) : "";
      parent.previousTablesSize = null;
    };

    window.onbeforeunload = function () {
      parent.subscription.unsubscribe();
    };

    this.subscription = messageService.getMessage().subscribe((message) => {
      if (this.loadingConfigurations) {
        return;
      }

      let numericData = this.isNumeric(message);

      let serverId, tabletype;
      if (numericData) {
        serverId = parseInt(message[0].substring(2));
        tabletype = message[1];
      } else {
        serverId = parseInt(message.identity.substring(2));
        tabletype = message.source;
      }

      // If new message contains exposure data but exposure table is hidden then return
      if (tabletype == "PositionsExposure" && !this.showingExposureTable) {
        return;
      }

      // TODO check that empty arrays received from sse are handled well
      if (this.isEmptyMessage(message, numericData)) {
        if (
          this.grids &&
          this.grids[serverId] &&
          this.grids[serverId].summary.gridOptions.hasOwnProperty("api") &&
          this.grids[serverId].summary.gridOptions.api != null
        ) {
          this.handleNewData(serverId, [], tabletype);
          // this.grids[serverId][
          //   tabletype == "PositionsSummary" ? "summary" : "exposure"
          // ].gridOptions.api.setRowData([]);
        }
        return;
      }

      if (
        (numericData && message[1] == "PositionsSummary") ||
        message.source == "PositionsSummary"
      ) {
        // Check that the payload matches the instance's definition (e.g grouped by symbol)
        this.checkConfigAndDataMatch(message, serverId, numericData);
      }

      let instanceConfig = this.ANInstanceConfigs.find(
        (el) => el.id == serverId
      );
      if (!instanceConfig) return;

      let instanceFrozen =
        instanceConfig.hasOwnProperty("freezeAnalytics") &&
        instanceConfig.freezeAnalytics;

      if (
        !this.grids ||
        instanceFrozen || // freezeAnalytics is set in checkConfigAndDataMatch and means that groupSummaryBySymbol changed so a page reload is needed
        this.reloadingAN
      ) {
        return;
      }
      this.handleNewData(
        serverId,
        numericData ? message[2] : message.data,
        numericData ? message[1] : message.source
      );
    });

    document.getElementById("htmlId").style.overflowY = "auto";
    if (this.fetchAnalyticInstancesFiltered.length == 0) {
      this.$emit("analytics-empty", {
        isEmpty: true,
      });
    } else {
      this.$emit("analytics-empty", {
        isEmpty: false,
      });
    }
  },
  created() {
    this.removeOldDB(); // Remove any leftovers from DB used in previous session
    this.getANInstanceConfigs();
  },
  beforeDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  },
  watch: {
    currentTabItem: {
      deep: true,
      handler(v) {
        if (!v.mobileModel && v.showMergeTabMobile) {
          setTimeout(() => {
            this.currentTabItem.showMergeTabMobile = false;
          }, 120);
        }
      },
    },
    mergeTabs: {
      deep: true,
      handler() {
        Object.keys(this.mergeTabs).forEach((el) => {
          let tab = this.mergeTabs[el];
          if (!tab.model) {
            // If menus are closed then they should be able to open on hover
            tab.addInstancesSelector = false;
            if (!tab.openOnHover) {
              tab.openOnHover = true;
              tab.showMergeTab = false;
            }
          }
        });
      },
    },
    analyticInstances() {
      this.focusOnTheRightTab();

      let freshInstances = this.getEnabledApplicationInstances;
      if (this.instances == null) this.instances = [];
      if (freshInstances.length) {
        // NOTE: might need to add an if(!loading) for case where fetchApplicationInstances() called before the fetchApplicationInstances() in created()
        let savedInstances = this.instances;
        freshInstances.forEach((inst) => {
          let hideSeperated = false;

          if (
            this.mergedInstances.some((el) => {
              // If at least one mergedInstance contains this inst and has hideSeperated == true
              return (
                el.subinstances.some((sub) => sub.id == inst.id) &&
                el.hideSeperated
              );
            })
          ) {
            hideSeperated = true;
          }

          if (
            savedInstances.every((el) => el.id != inst.id) && // if freshInstance doesnt exist in savedInstances
            !hideSeperated // and if freshInstance shouldn't be hidden because hideSeperated = false
          ) {
            this.addNewInstance(inst.id);
          }
        });

        let itemsToRemove = savedInstances.filter(
          (
            savedInst // if savedInstance is nor in freshInstances and nor in mergedInstances -> remove it
          ) =>
            freshInstances.every((inst) => savedInst.id != inst.id) &&
            this.mergedInstances.every((inst) => savedInst.id != inst.id)
        );
        if (freshInstances.length && itemsToRemove.length) {
          // NOTE: might need to add an if(!loading) to remove items from saved ONLY if Application Instances are already fetched from server
          this.removeInstanceFromSaved(itemsToRemove);
        }
      }
    },
    fetchAnalyticInstancesFiltered(instances) {
      if (this.loadingConfigurations) return;

      // Recalculate instances that are available for merging on each of the merged instances
      this.calculateMergedInstancesInfo();
      let mergeTabs = {};
      instances.forEach((el) => {
        // make mergeTabs = this.mergeTabs and add the missing tabs for new instances
        mergeTabs[el.id] =
          this.mergeTabs[el.id] == undefined
            ? { model: false, showMergeTab: false, openOnHover: true }
            : Object.assign(this.mergeTabs[el.id]);
      });
      this.mergedInstances.forEach((merged) => {
        // add missing mergeTabs of mergedInstances
        if (!mergeTabs.hasOwnProperty(merged.id))
          mergeTabs[merged.id] = Object.assign(
            { model: false, openOnHover: true, addInstancesSelector: false },
            merged
          );
      });

      this.mergeTabs = mergeTabs;

      // Reload dealio if an instance is added while on empty page
      if (
        this.analyticInstancesInitialLoaded &&
        this.analyticInstancesInitialLoadedValues.length == 0 &&
        instances.length > 0 &&
        !this.reloadingAN
      ) {
        this.reloadingAN = true;
        this.$notifier.warn(
          "An Analytics instance was added reloading dealio in a few seconds.."
        );
        setTimeout(() => {
          window.location.reload();
        }, 6000);
      }

      this.refreshMergedInstances(instances); // call refreshMergedInstances after checking if page needs a reload so errors dont arise

      // addingNewGrid has to be true as soon as instances change (for rendering errors)
      this.addingNewGrid = true;
      // Handle add/delete of an instance

      if (
        this.analyticInstancesInitialLoaded &&
        this.analyticInstancesInitialLoadedValues.length != instances.length &&
        !this.reloadingAN
      ) {
        if (
          this.analyticInstancesInitialLoadedValues.length < instances.length
        ) {
          this.addNewGrids();
        } else {
          this.removeOldGrids();
        }
      } else if (!this.reloadingAN) {
        this.analyticInstancesInitialLoaded = true;
      }
      this.analyticInstancesInitialLoadedValues = instances;
    },
    getMiniDrawer(value) {
      setTimeout(() => {
        this.fitColumns("getMiniDrawer");
      }, 220);
    },
  },
};
</script>
<style lang="scss">
//  Use css variables to customize ag-grid theme
.ag-theme-balham-dark {
  --ag-control-panel-background-color: #1c6e59 !important;
}

.ag-theme-balham {
  --ag-control-panel-background-color: #1c6e59 !important;
}

//
.ag-column-drop-wrapper .ag-column-drop-horizontal {
  border-bottom: none !important;
}

@import "../../node_modules/@ag-grid-community/core/dist/styles/ag-grid.css";
@import "../../node_modules/@ag-grid-community/core/dist/styles/ag-theme-balham/sass/ag-theme-balham-mixin.scss";
@import "../../node_modules/@ag-grid-community/core/dist/styles/ag-theme-balham-dark/sass/ag-theme-balham-dark-mixin.scss";

.ag-theme-custom-balham-vue {
  @include ag-theme-balham(
    (
      header-cell-moving-background-color: #47bd96,
      header-background-color: #47bd96,
      odd-row-background-color: #f5f5f5,
      control-panel-background-color: #1c6e59,
      hover-color: #d8d8db,
      chip-background-color: #47bd96,
      primary-color: #47bd96,
      disabled-foreground-color: rgba(245, 245, 245, 0.38),
      secondary-foreground-color: #2b2b2b,
    )
  );

  .ag-menu-option-active {
    background-color: #2661ad;
    color: white;
  }
}

.ag-theme-custom-balham-dark-vue {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);

  @include ag-theme-balham-dark(
    (
      header-cell-moving-background-color: #47bd96,
      header-background-color: #437974,
      control-panel-background-color: #001c27,
      chip-background-color: #47bd96,
      primary-color: #47bd96,
    )
  );

  .ag-menu-option-active {
    background-color: #2661ad;
    color: white;
  }

  .ag-column-drop-horizontal-cell {
    background-color: transparent;
    border-radius: 2px;
    border: 1px solid #1b6e5a;
  }

  .ag-header-row {
    background-color: #437974;
  }

  .ag-header-cell::after {
    background-color: #685aa1;
  }

  .ag-icon-grip {
    color: #685aa1;
    font-size: 1.8em;
  }

  .ag-icon-cancel {
    color: #4abd96;
  }
}
</style>

<style scoped>
.fade-enter-active {
  -webkit-animation: tableTransitionOpacityIn 0.3s ease-in-out forwards;
  animation: tableTransitionOpacityIn 0.3s ease-in-out forwards;
}

.fade-enter {
  opacity: 0.8;
}

.fade-leave-to {
  opacity: 0.5;
  -webkit-animation: tableTransitionOpacityOut 0.2s ease-in-out forwards;
  animation: tableTransitionOpacityOut 0.2s ease-in-out forwards;
}

@keyframes tableTransitionOpacityOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes tableTransitionOpacityIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>

<style src="../css/utilities/analytics.css"></style>
<style scoped src="../css/utilities/scoped/analytics.css"></style>
<style scoped src="../css/dealio.scss" lang="scss" />
